{
  "account.account": "Profil i sigurnost",
  "account.accountDeleted": "Vaš račun je uspješno izbrisan.",
  "account.accountDescription": "Ime, lozinka, brisanje računa",
  "account.accountSection": "Račun",
  "account.changeEmail": "Promijeni e-mail",
  "account.changePassword": "Promijeni lozinku",
  "account.currentPassword": "Trenutna lozinka",
  "account.dangerZone": "Rizična zona",
  "account.deleteAccount": "Izbriši račun",
  "account.deleteAccountConfirmation": "Jeste li sigurni da želite izbrisati svoj račun? Ova radnja je nepovratna.",
  "account.deleteAccountDescription": "Ova radnja briše vaš račun i sve vaše podatke. Nema povratka.",
  "account.emailChange": "Promijeni e-mail adresu",
  "account.emailChangeConfirmation": "Potvrda promjene e-maila",
  "account.emailChangeFailure": "Poveznica za promjenu e-maila je nevažeća ili je istekla.",
  "account.emailChangeIntro": "Unesite novu e-mail adresu i trenutnu lozinku. Na novu adresu poslat ćemo poveznicu: vaš e-mail promijenit će se tek kada je otvorite.",
  "account.emailChangeNeedsPassword": "Da biste promijenili e-mail adresu, najprije postavite lozinku. Za to ćemo vam e-mailom poslati poveznicu. Ostajete prijavljeni.",
  "account.emailChangeSetPasswordFirst": "Da biste promijenili e-mail adresu, najprije postavite lozinku.",
  "account.emailChangeSuccess": "Vaš e-mail je uspješno promijenjen u {newEmail}.",
  "account.emailChangeSuccessNoAddress": "Vaša e-mail adresa uspješno je promijenjena.",
  "account.emailChangeVerificationSent": "Verifikacijski e-mail je poslan na vašu novu e-mail adresu. Provjerite svoju pristiglu poštu i kliknite na poveznicu za potvrdu promjene.",
  "account.manageAccount": "Upravljaj računom",
  "account.newEmailAddress": "Nova e-mail adresa",
  "account.newPassword": "Nova lozinka",
  "account.newPasswordAgain": "Ponovite novu lozinku",
  "account.noPasswordExplanation": "Vaš račun još nema SmartMixin lozinku jer se prijavljujete putem Googlea, Applea ili Facebooka. Poslat ćemo vam e-mailom poveznicu za postavljanje lozinke. Ostajete prijavljeni.",
  "account.oldPassword": "Stara lozinka",
  "account.passwordChange": "Promjena lozinke",
  "account.passwordChangeDescription": "Održite svoj račun sigurnim",
  "account.passwordUpdated": "Lozinka je uspješno promijenjena.",
  "account.profile": "Profil",
  "account.profileUpdated": "Profil je uspješno promijenjen.",
  "account.reauthAccountMismatchApple": "Taj Apple račun nije onaj povezan sa SmartMixinom. Pokušajte ponovno s Apple računom kojim se prijavljujete.",
  "account.reauthAccountMismatchGoogle": "Taj Google račun nije onaj povezan sa SmartMixinom. Pokušajte ponovno i odaberite Google račun kojim se prijavljujete.",
  "account.reauthAccountMismatchGoogleNamed": "Taj Google račun nije onaj povezan sa SmartMixinom. Pokušajte ponovno i odaberite {email}.",
  "account.reauthConfirmBody": "Da biste promijenili e-mail adresu, potvrdite računom kojim se prijavljujete.",
  "account.reauthConfirmed": "Potvrđeno putem usluge {provider}",
  "account.reauthConfirmTitle": "Potvrdite da ste to vi",
  "account.reauthExpired": "Vaša je potvrda istekla. Ponovno potvrdite da biste nastavili.",
  "account.reauthFailed": "Nismo mogli potvrditi da ste to vi. Pokušajte ponovno.",
  "account.reauthPopupBlocked": "Preglednik je blokirao Appleov prozor. Ponovno pritisnite gumb.",
  "account.reauthProviderUnavailable": "{provider} trenutačno ne odgovara. Pokušajte ponovno za nekoliko minuta.",
  "account.reauthSetPasswordInstead": "Radije postavi lozinku",
  "account.reauthThrottled": "U kratkom ste vremenu nekoliko puta pokušali potvrditi. Pokušajte kasnije.",
  "account.sendSetPasswordLink": "Pošalji mi poveznicu",
  "account.sendSetPasswordLinkLong": "Pošalji mi poveznicu za postavljanje lozinke",
  "account.setPassword": "Postavi lozinku",
  "account.setPasswordDescription": "Vaš račun još nema lozinku",
  "account.setPasswordFirst": "Najprije postavite lozinku",
  "account.setPasswordLinkError": "Poveznicu nije bilo moguće poslati. Provjerite vezu i pokušajte ponovno.",
  "account.setPasswordLinkRateLimited": "U kratkom ste vremenu zatražili nekoliko poveznica. Potražite najnoviju u pristigloj pošti i mapi neželjene pošte ili pokušajte kasnije.",
  "account.setPasswordLinkResend": "Pošalji ponovno",
  "account.setPasswordLinkRetry": "Pokušaj ponovno",
  "account.setPasswordLinkSent": "Poslali smo poveznicu na {email}. Otvorite je, odaberite lozinku i zatim se vratite ovamo.",
  "account.signedInAs": "Prijavljeni kao",
  "account.updateYourProfile": "Ažurirajte vaš profil",
  "account.updateYourProfileDescription": "Ime i postavke prikaza",
  "addons.accountOnHold": "Veza vašeg računa je istekla. Ponovno se povežite za nastavak ažuriranja podataka.",
  "addons.accountOnHoldTitle": "Račun pauziran",
  "addons.ambientWeatherCreateAndRetrieveApiKey": "Izradite i dohvatite svoj API ključ s ove veze",
  "addons.ambientWeatherDescription": "Meteorološke postaje Ambient Weather (WS-5000, WS-2000, WS-2902C,...)",
  "addons.apiKey": "API ključ",
  "addons.applicationKey": "Aplikacijski ključ",
  "addons.availableServices": "Dostupno",
  "addons.cannotDisconnectLastAccount": "Nije moguće odspojiti jedinu metodu prijave. Prvo dodajte drugu metodu prijave.",
  "addons.connect": "Poveži",
  "addons.connected": "Povezano",
  "addons.connectedAccounts": "Povezani računi",
  "addons.connectedAccountsDescription": "Apple, Google, Facebook",
  "addons.connectedAccountsLoading": "Učitavanje povezanih računa…",
  "addons.connectedServices": "Povezano",
  "addons.connectedSince": "Povezano od {date}",
  "addons.connectionSection": "Veza",
  "addons.connectionSuccess": "{provider} račun uspješno povezan",
  "addons.davisApiSecret": "Tajni ključ API",
  "addons.davisApiV2Key": "API ključ V2",
  "addons.davisDescription": "Davis meteorološke postaje (Vantage Vue, Vantage Pro2,...)",
  "addons.davisRetrieveApiKey": "Dohvatite svoje V2 API ključeve s ove veze",
  "addons.disconnect": "Odspoji",
  "addons.disconnectConfirmation": "Jeste li sigurni da želite odspojiti {provider} račun?",
  "addons.disconnectEnergyConfirmation": "SmartMixin će prestati sinkronizirati Netatmo Energy i uklonit će vaše kuće iz SmartMixina. Vaš Netatmo račun i uređaji neće biti zahvaćeni.",
  "addons.disconnectEnergyDescription": "Zaustavlja sinkronizaciju i uklanja vaše kuće iz SmartMixina.",
  "addons.disconnectionSuccess": "{provider} račun uspješno odspojen",
  "addons.disconnectProviderDescription": "Zaustavlja sinkronizaciju i briše postaje ove usluge i njihovu povijest.",
  "addons.disconnectServiceConfirmation": "SmartMixin će prestati sinkronizirati uslugu {provider} i izbrisat će postaje te usluge i cijelu njihovu povijest. Sam vaš račun na usluzi {provider} neće biti zahvaćen.",
  "addons.disconnectServiceTitle": "Odspojiti uslugu {provider}?",
  "addons.ecowittCreateAndRetrieveKeys": "Izradite i dohvatite svoj API ključ i ključ aplikacije putem ove veze",
  "addons.ecowittDescription": "Ecowitt nudi profesionalne meteorološke postaje, bežične unutarnje/vanjske termometre, kišomjere visoke preciznosti, senzore kvalitete zraka i još mnogo toga.",
  "addons.helpLink": "Kako povezati {provider}",
  "addons.integrationsSection": "Integracije",
  "addons.myAcuriteAccountOnHold": "Vaš račun je stavljen na čekanje. Molimo unesite svoju lozinku kako biste ponovno povezali svoj račun",
  "addons.myAcuriteDescription": "AcuRite je marka meteoroloških postaja broj 1 u Sjevernoj Americi. Kao predvodnik u tehnologiji mjerenja vremena, temperature i vremenskih uvjeta, AcuRite vam pruža detaljne informacije o vašem unutarnjem i vanjskom okruženju kako biste s povjerenjem mogli planirati svoj dan.",
  "addons.netatmoEnergy": "Netatmo Energy",
  "addons.netatmoEnergyDescription": "Da promijenite temperaturu u domu, bilo iz kreveta bilo sa druge strane svijeta, koristite Netatmo Thermostat.",
  "addons.netatmoWeather": "Netatmo Weather",
  "addons.netatmoWeatherDescription": "Vaša osobna meteorološka postaja",
  "addons.notConnected": "Nije povezano",
  "addons.or": "ili",
  "addons.providerAccountDisconnected": "Veza s vašom meteorološkom uslugom je istekla. Ponovno se povežite za nastavak ažuriranja podataka.",
  "addons.reconnect": "Poveži ponovo",
  "addons.socialConnectionsIntro": "Povežite svoje društvene račune za brzu prijavu. Možete povezivati ili odspajati račune u bilo kojem trenutku.",
  "addons.weatherflowAccessToken": "Pristupni token",
  "addons.weatherflowCreateToken": "Stvorite i dohvatite svoj token putem ove veze",
  "addons.weatherflowTempestDescription": "Meteorološki sustav Tempest s ugrađenim mjeračem vjetra i kišomjerom",
  "addons.weatherServices": "Meteorološke usluge",
  "addons.weatherServicesConnected": "{count, plural, =0 {Nema povezanih usluga} one {# povezana usluga} few {# povezane usluge} other {# povezanih usluga}}",
  "addons.weatherServicesDescription": "Povežite Netatmo, Davis, Weatherflow i ostalo",
  "addons.wundergroundApiKey": "API ključ",
  "addons.wundergroundDescription": "Weather Underground je globalna zajednica ljudi koji povezuju podatke sa senzora za okoliš poput meteoroloških postaja i monitora kvalitete zraka kako bismo mogli isporučiti bogate, hiperlokalne podatke koji su vam potrebni da potaknete svoje strasti.",
  "addons.wundergroundRemoveStationDescription": "Stanica se uklanja s vašeg SmartMixin računa. Osim ako ju je dodao i neki drugi SmartMixin račun, stanica i povijest koju je SmartMixin za nju zabilježio bit će izbrisani. Na Weather Undergroundu ništa se ne mijenja.",
  "addons.wundergroundRemoveStationTitle": "Izbrisati {station}?",
  "addons.wundergroundRetrieveApiKey": "Dohvatite svoj API ključ s ove veze",
  "addons.wundergroundStationId": "ID postaje",
  "airQuality.adviceActivityGood": "Idealan dan za kretanje na otvorenom",
  "airQuality.adviceActivityHazardous": "Izbjegavajte svaku tjelesnu aktivnost na otvorenom",
  "airQuality.adviceActivityLabel": "Tjelesna aktivnost",
  "airQuality.adviceActivityModerate": "Dobar dan za kretanje na otvorenom",
  "airQuality.adviceActivitySensitive": "Razmislite o kraćim i manje intenzivnim aktivnostima na otvorenom",
  "airQuality.adviceActivityUnhealthy": "Smanjite duge ili intenzivne aktivnosti i češće se odmarajte",
  "airQuality.adviceActivityVeryUnhealthy": "Izbjegavajte duge ili intenzivne aktivnosti; razmislite o premještanju u zatvoreni prostor",
  "airQuality.adviceGroupsGood": "Nisu potrebne posebne mjere opreza",
  "airQuality.adviceGroupsHazardous": "Ostanite u zatvorenom prostoru i smanjite aktivnost",
  "airQuality.adviceGroupsLabel": "Osjetljive skupine",
  "airQuality.adviceGroupsModerate": "Osobito osjetljive osobe: kraće i manje intenzivne aktivnosti",
  "airQuality.adviceGroupsSensitive": "Kraće i manje intenzivne aktivnosti na otvorenom, uz više odmora",
  "airQuality.adviceGroupsUnhealthy": "Izbjegavajte duge ili intenzivne aktivnosti na otvorenom; razmislite o premještanju u zatvoreni prostor",
  "airQuality.adviceGroupsVeryUnhealthy": "Izbjegavajte svaku tjelesnu aktivnost na otvorenom; odgodite je ili premjestite u zatvoreni prostor",
  "airQuality.adviceTimingLabel": "Kada izaći van",
  "airQuality.adviceTimingMorning": "Najbolje ujutro — tada je razina ozona niža",
  "airQuality.airQuality": "Kvaliteta zraka",
  "airQuality.airQualityIndex": "Indeks kvalitete zraka",
  "airQuality.aqiForecast": "Prognoza kvalitete zraka",
  "airQuality.co2Fresh": "Svjež",
  "airQuality.co2GettingStale": "Blago zagušljiv",
  "airQuality.co2Stale": "Zagušljiv",
  "airQuality.dailyForecast": "Dnevna prognoza",
  "airQuality.dominantPollutant": "Dominantni onečišćivač",
  "airQuality.expectedPeak": "Očekivani vrhunac",
  "airQuality.expectedPeakAt": "Očekivani vrhunac {value} · {band} · {time}",
  "airQuality.good": "Dobro",
  "airQuality.goodDescription": "Kvaliteta zraka je zadovoljavajuća i zagađenost zraka predstavlja malu opasnost.",
  "airQuality.hazardous": "Opasno",
  "airQuality.hazardousDescription": "Zdravstveno upozorenje: sve osobe su pod rizikom ozbiljnih zdravstvenih tegoba.",
  "airQuality.indoorAirQuality": "Kvaliteta zraka u zatvorenom prostoru",
  "airQuality.moderate": "Umjereno",
  "airQuality.moderateDescription": "Kvaliteta zraka je prihvatljiva; ipak manji broj osjetljivih osoba koje su izrazito osjetljive na zagađenost zraka može imati tegobe",
  "airQuality.noForecastForLocation": "Za ovu lokaciju nije dostupna prognoza kvalitete zraka.",
  "airQuality.now": "Sada",
  "airQuality.nowCastAqi": "NowCast AQI",
  "airQuality.pollutants": "Onečišćujuće tvari",
  "airQuality.recommendations": "Preporuke",
  "airQuality.sensitiveUnhealthy": "Nezdravo za osjetljive skupine",
  "airQuality.sensitiveUnhealthyDescription": "Jako osjetljive osobe mogu osjetiti tegobe. Prosječna zdrava osoba neće imati problema.",
  "airQuality.subIndex": "AQI podindeks",
  "airQuality.ugm3": "µg/m³",
  "airQuality.understandIndex": "Razumijevanje indeksa",
  "airQuality.unhealthy": "Nezdravo",
  "airQuality.unhealthyDescription": "Svi će osjetiti tegobe. Jako osjetljive osobe mogu imati izraženije simptome.",
  "airQuality.veryUnhealthy": "Vrlo nezdravo",
  "airQuality.veryUnhealthyDescription": "Zdravstveno upozorenje o izvanrednom stanju. Vjerojatno će biti pogođeno cijelo stanovništvo.",
  "alerts.addAlert": "Dodajte upozorenje",
  "alerts.addCondition": "Dodaj uvjet",
  "alerts.alertAdded": "Upozorenje je uspješno dodano",
  "alerts.alertAuthorizationNotice": "Upozorenja mogu funkcionirati samo ako dopustite SmartMixinu da prikazuje obavijesti",
  "alerts.alertDeleted": "Upozorenje je uspješno izbrisano",
  "alerts.alertName": "Naziv upozorenja",
  "alerts.alertWhen": "Želim biti upozoren kada:",
  "alerts.aqiGreaterThan": "AQI veći od",
  "alerts.aqiGreaterThanThreshold": "AQI iznad praga {value}{unit}",
  "alerts.aqiLessThan": "AQI manji od",
  "alerts.aqiLessThanThreshold": "AQI ispod {value}{unit} praga",
  "alerts.atLeastOneCondition": "Morate dodati barem jedan uvjet",
  "alerts.co2GreaterThan": "CO2 veći od",
  "alerts.co2GreaterThanThreshold": "CO2 iznad {value}{unit} praga",
  "alerts.co2LessThan": "CO2 manji od",
  "alerts.co2LessThanThreshold": "CO2 ispod {value}{unit} praga",
  "alerts.conditions": "Uvjeti",
  "alerts.conditionsDroppedOnStationChange": "Ova postaja ne podržava, uklonjeno: {conditions}",
  "alerts.createAlert": "Kreiraj upozorenje",
  "alerts.dailyPrecipitationGreaterThan": "Dnevne oborine veće od",
  "alerts.dailyPrecipitationGreaterThanThreshold": "Dnevne oborine iznad praga od {value}{unit}",
  "alerts.deleteAlert": "Izbriši upozorenje",
  "alerts.deviceOnlyAlertNotice": "Vaša upozorenja spremaju se samo na ovaj uređaj. Prijavite se kako biste ih povezali sa svojim računom.",
  "alerts.editAlert": "Uredi upozorenje",
  "alerts.editCondition": "Promjena uvjeta",
  "alerts.gustSpeedGreaterThan": "Udar vjetra veći od",
  "alerts.gustSpeedGreaterThanThreshold": "Udar vjetra iznad {value}{unit} praga",
  "alerts.gustSpeedLessThan": "Udar vjetra manji od",
  "alerts.gustSpeedLessThanThreshold": "Udar vjetra ispod {value}{unit} praga",
  "alerts.heatIndexGreaterThan": "Indeks toplote veći od",
  "alerts.heatIndexGreaterThanThreshold": "Indeks toplote iznad {value}{unit} praga",
  "alerts.heatIndexLessThan": "Indeks toplote manji od",
  "alerts.heatIndexLessThanThreshold": "Indeks toplote ispod {value}{unit} praga",
  "alerts.humidexGreaterThan": "Humidex veći od",
  "alerts.humidexGreaterThanThreshold": "Humidex iznad {value}{unit} praga",
  "alerts.humidexLessThan": "Humidex manji od",
  "alerts.humidexLessThanThreshold": "Humidex ispod {value}{unit} praga",
  "alerts.humidityGreaterThan": "Vlažnost iznad",
  "alerts.humidityGreaterThanThreshold": "Vlažnost iznad praga {value}{unit}",
  "alerts.humidityLessThan": "Vlažnost ispod",
  "alerts.humidityLessThanThreshold": "Vlažnost ispod praga od {value}{unit}",
  "alerts.inProgress": "U tijeku",
  "alerts.leafWetnessGreaterThan": "Vlažnost lišća iznad",
  "alerts.leafWetnessGreaterThanThreshold": "Vlažnost lišća iznad praga od {value}{unit}",
  "alerts.leafWetnessLessThan": "Vlažnost lišća ispod",
  "alerts.leafWetnessLessThanThreshold": "Vlažnost lišća ispod praga od {value}{unit}",
  "alerts.myAlerts": "Moja upozorenja",
  "alerts.noAlertsForStation": "Za ovu postaju još nema konfiguriranih upozorenja",
  "alerts.noConfiguredAlert": "Još nemate upozorenje, dodajte ga",
  "alerts.noiseGreaterThan": "Buka veća od",
  "alerts.noiseGreaterThanThreshold": "Buka iznad {value}{unit} praga",
  "alerts.noiseLessThan": "Buka manja od",
  "alerts.noiseLessThanThreshold": "Buka ispod {value}{unit} praga",
  "alerts.noteOnConditions": "Imajte na umu da se upozorenje aktivira kada se potvrde svi dolje navedeni uvjeti",
  "alerts.noTriggerHistory": "Ovo upozorenje još nije aktivirano.",
  "alerts.pm10GreaterThan": "PM 10 veći od",
  "alerts.pm10GreaterThanThreshold": "PM 10 iznad {value}{unit} praga",
  "alerts.pm10LessThan": "PM 10 manje od",
  "alerts.pm10LessThanThreshold": "PM 10 ispod {value}{unit} praga",
  "alerts.pm1GreaterThan": "PM 1 veći od",
  "alerts.pm1GreaterThanThreshold": "PM 1 iznad {value}{unit} praga",
  "alerts.pm1LessThan": "PM 1 manje od",
  "alerts.pm1LessThanThreshold": "PM 1 ispod {value}{unit} praga",
  "alerts.pm2p5GreaterThan": "PM 2,5 veći od",
  "alerts.pm2p5GreaterThanThreshold": "PM 2,5 iznad {value}{unit} praga",
  "alerts.pm2p5LessThan": "PM 2,5 manje od",
  "alerts.pm2p5LessThanThreshold": "PM 2,5 ispod {value}{unit} praga",
  "alerts.postStormSummary": "Sažetak nakon oborina",
  "alerts.postStormSynopsisHelper": "Primit ćete obavijest sa sažetkom nakon svake kiše.",
  "alerts.postStormSynopsisSoleCondition": "Sažetak nakon oborina ne može se kombinirati s drugim uvjetima.",
  "alerts.precipitationGreaterThan": "Satne oborine veće od",
  "alerts.precipitationGreaterThanThreshold": "Satne oborine iznad praga od {value}{unit}",
  "alerts.pressureGreaterThan": "Tlak veći od",
  "alerts.pressureGreaterThanThreshold": "Tlak iznad {value}{unit} praga",
  "alerts.pressureLessThan": "Tlak manji od",
  "alerts.pressureLessThanThreshold": "Tlak ispod {value}{unit} praga",
  "alerts.pushPromptAccept": "Uključi obavijesti",
  "alerts.pushPromptBody": "Upozorenja vaše postaje stižu vam kao obavijesti. Uključite ih kako ne biste propustili nijedno.",
  "alerts.pushPromptBodyCreated": "Upozorenje je spremljeno. Uključite obavijesti kako bi vas dosegnulo kad se aktivira.",
  "alerts.pushPromptTitle": "Primajte obavijest kad se vaša upozorenja aktiviraju",
  "alerts.rainRateGreaterThan": "Intenzitet kiše veći od",
  "alerts.rainRateGreaterThanThreshold": "Intenzitet kiše iznad praga od {value}{unit}",
  "alerts.sensorNotReporting": "Ovaj senzor trenutačno ne šalje podatke. Upozorenje će se nastaviti kada ponovno počne slati.",
  "alerts.soilMoistureGreaterThan": "Vlažnost tla iznad",
  "alerts.soilMoistureGreaterThanThreshold": "Vlažnost tla iznad praga od {value}{unit}",
  "alerts.soilMoistureLessThan": "Vlažnost tla ispod",
  "alerts.soilMoistureLessThanThreshold": "Vlažnost tla ispod praga od {value}{unit}",
  "alerts.solarRadiationGreaterThan": "Sunčevo zračenje veće od",
  "alerts.solarRadiationGreaterThanThreshold": "Sunčevo zračenje iznad {value}{unit} praga",
  "alerts.solarRadiationLessThan": "Sunčevo zračenje manje od",
  "alerts.solarRadiationLessThanThreshold": "Sunčevo zračenje ispod {value}{unit} praga",
  "alerts.stationAlerts": "Upozorenja za ovu postaju",
  "alerts.stationNoLongerReports": "Ova postaja više ne šalje podatke, pa se ovo upozorenje ne može aktivirati.",
  "alerts.stormChartUnavailable": "Povijest kiše za ove oborine nije dostupna.",
  "alerts.stormDetail": "Sažetak oborina",
  "alerts.stormDuration": "Trajanje",
  "alerts.stormEnd": "Kraj",
  "alerts.stormPeakRate": "Najveći intenzitet kiše",
  "alerts.stormStart": "Početak",
  "alerts.stormTotal": "Ukupne oborine",
  "alerts.temperatureGreaterThan": "Temperatura iznad",
  "alerts.temperatureGreaterThanThreshold": "Temperatura iznad {value}{unit} praga",
  "alerts.temperatureLessThan": "Temperatura ispod",
  "alerts.temperatureLessThanThreshold": "Temperatura ispod {value}{unit} praga",
  "alerts.thresholdOutOfRange": "Mora biti između {min} i {max}",
  "alerts.thswGreaterThan": "THSW veći od",
  "alerts.thswGreaterThanThreshold": "THSW iznad {value}{unit} praga",
  "alerts.thswLessThan": "THSW manji od",
  "alerts.thswLessThanThreshold": "THSW ispod {value}{unit} praga",
  "alerts.thwGreaterThan": "THW veći od",
  "alerts.thwGreaterThanThreshold": "THW iznad {value}{unit} praga",
  "alerts.thwLessThan": "THW manji od",
  "alerts.thwLessThanThreshold": "THW ispod {value}{unit} praga",
  "alerts.triggerHistory": "Povijest upozorenja",
  "alerts.uvGreaterThan": "UV veći od",
  "alerts.uvGreaterThanThreshold": "UV iznad {value}{unit} praga",
  "alerts.uvLessThan": "UV niži od",
  "alerts.uvLessThanThreshold": "UV ispod {value}{unit} praga",
  "alerts.visibilityGreaterThanThreshold": "Vidljivost iznad {value}{unit} praga",
  "alerts.visibilityLessThanThreshold": "Vidljivost ispod {value}{unit} praga",
  "alerts.visiblityGreaterThan": "Vidljivost veća od",
  "alerts.visiblityLessThan": "Vidljivost manja od",
  "alerts.whichMeasure": "Za koju mjernu veličinu želite biti upozoreni?",
  "alerts.whichModule": "Na koji biste modul željeli biti upozoreni?",
  "alerts.whichSensor": "Na koji biste senzor željeli biti upozoreni?",
  "alerts.windChillGreaterThan": "Hlađenje vjetra veće od",
  "alerts.windChillGreaterThanThreshold": "Hlađenje vjetra iznad {value}{unit} praga",
  "alerts.windChillLessThan": "Hlađenje vjetra manje od",
  "alerts.windChillLessThanThreshold": "Hlađenje vjetra ispod {value}{unit} praga",
  "alerts.windSpeedGreaterThan": "Vjetar jači od",
  "alerts.windSpeedGreaterThanThreshold": "Vjetar iznad {value}{unit} praga",
  "alerts.windSpeedLessThan": "Vjetar manje od",
  "alerts.windSpeedLessThanThreshold": "Vjetar ispod {value}{unit} praga",
  "appUpdate.openInBrowser": "Otvori u pregledniku",
  "appUpdate.reload": "Ponovno učitaj",
  "appUpdate.update": "Ažuriraj",
  "appUpdate.updateAvailable": "Dostupno je ažuriranje",
  "appUpdate.updateAvailableOpenAppStore": "Dodirnite za otvaranje App Storea",
  "appUpdate.updateAvailableOpenGooglePlay": "Dodirnite za otvaranje Google Playa",
  "appUpdate.updateAvailableVersion": "Dostupno je ažuriranje: v{version}",
  "appUpdate.upgradeRequiredAndroid": "Potrebna je nadogradnja aplikacije. Posjetite Google Play radi nadogradnje.",
  "appUpdate.upgradeRequiredIos": "Potrebna je nadogradnja aplikacije. Posjetite App Store radi nadogradnje.",
  "appUpdate.upgradeRequiredTitle": "Ažurirajte SmartMixin za nastavak",
  "appUpdate.webUpdateAvailable": "Dostupna je nova verzija aplikacije SmartMixin. Ponovno učitajte stranicu kako biste je koristili.",
  "astral.aboveHorizonAllDay": "Cijeli dan iznad horizonta",
  "astral.aboveTheHorizon": "iznad horizonta",
  "astral.apparentSize": "Prividni promjer",
  "astral.apparentSizeAcross": "{size} u promjeru",
  "astral.astronomicalDawn": "Astronomska zora",
  "astral.astronomicalDusk": "Astronomski sumrak",
  "astral.belowHorizonAllDay": "Cijeli dan ispod horizonta",
  "astral.belowHorizonSince": "Ispod horizonta od {time}",
  "astral.belowHorizonSinceOn": "Ispod horizonta od {day} {time}",
  "astral.brightAllNight": "Svijetlo cijelu noć — nikad potpuno mračno",
  "astral.brightestMoment": "Najsvjetliji trenutak",
  "astral.civilDawn": "Građanska zora",
  "astral.civilDusk": "Građanski sumrak",
  "astral.darkSkyBetween": "Tamno nebo {from} → {to}",
  "astral.darkSkyWindow": "Tamno nebo {from} → {to} · {duration} bez Mjeseca",
  "astral.dayLength": "Duljina dana",
  "astral.daylightThroughTheYear": "Duljina dana tijekom godine",
  "astral.dayOfCycle": "dan {day} od {total}",
  "astral.doesNotOccurToday": "Danas se ne događa",
  "astral.domeHint": "Povucite za kretanje kroz noć",
  "astral.domeReadout": "{time} · {altitude} · {direction}",
  "astral.earliestSunrise": "Najraniji izlazak sunca",
  "astral.earliestSunset": "Najraniji zalazak sunca",
  "astral.equinox": "Ravnodnevica",
  "astral.equinoxIn": "Ravnodnevica za {days, plural, one {# dan} few {# dana} other {# dana}}",
  "astral.evening": "Večer",
  "astral.exactPhaseAt": "Točno u {time}",
  "astral.firstQuarter": "Prva četvrt",
  "astral.firstSunriseIn": "Prvi izlazak sunca za {days, plural, one {# dan} few {# dana} other {# dana}}",
  "astral.firstSunsetIn": "Prvi zalazak sunca za {days, plural, one {# dan} few {# dana} other {# dana}}",
  "astral.fullMoon": "Puni mjesec",
  "astral.goldenHourBegins": "Početak zlatnog sata",
  "astral.goldenHourEnds": "Kraj zlatnog sata",
  "astral.highestPoint": "Najviša točka",
  "astral.inDays": "za {days, plural, one {# dan} few {# dana} other {# dana}}",
  "astral.lastQuarter": "Zadnja četvrt",
  "astral.latestSunrise": "Najkasniji izlazak sunca",
  "astral.latestSunset": "Najkasniji zalazak sunca",
  "astral.litShort": "Osvijetl.",
  "astral.longestDay": "Najdulji dan",
  "astral.lowestPoint": "Najniža točka",
  "astral.maxAltitudeShort": "Maks.",
  "astral.midday": "Podne",
  "astral.midnightSun": "Ponoćno sunce",
  "astral.midnightSunPeriod": "Ponoćno sunce",
  "astral.milestoneFootnotePolar": "Ovdje sunce {days, plural, one {# dan} few {# dana} other {# dana}} u godini niti izlazi niti zalazi, pa popis umjesto uobičajenih krajnosti izlaska i zalaska pokazuje kada se to događa.",
  "astral.milestoneFootnoteTemperate": "Najraniji zalazak i najkasniji izlazak ne padaju na najkraći dan — ta dva datuma određuje jednadžba vremena, a ne solsticij.",
  "astral.moon": "Mjesec",
  "astral.moonAltitude": "Visina",
  "astral.moonDirection": "Azimut",
  "astral.moonDistance": "Udaljenost",
  "astral.moonlessFor": "{duration} bez Mjeseca",
  "astral.moonPhases": "Mjesečeve mijene",
  "astral.moonrise": "Izlazak mjeseca",
  "astral.moonset": "Zalazak mjeseca",
  "astral.moonUpAllNight": "Mjesec je iznad horizonta cijelu noć",
  "astral.moonWashesOutNight": "Mjesec je iznad horizonta od {rise} do {set} i osvjetljava cijelu noć",
  "astral.morning": "Jutro",
  "astral.nauticalDawn": "Nautička zora",
  "astral.nauticalDusk": "Nautički sumrak",
  "astral.newMoon": "Mladi mjesec",
  "astral.nextDay": "+1 dan",
  "astral.nextProperlyDarkNight": "Sljedeća uistinu tamna noć",
  "astral.nextRise": "sljedeći izlazak u {time}",
  "astral.nextRiseOn": "sljedeći izlazak {day} u {time}",
  "astral.nextSevenNights": "Sljedećih sedam noći",
  "astral.nightDate": "Datum",
  "astral.noAstronomicalDarknessTonight": "Noćas nema astronomske tame",
  "astral.noDarkNightAhead": "Nema je u sljedeća dva tjedna",
  "astral.noStationLocation": "Nepoznata lokacija",
  "astral.noStationLocationDescription": "Ova postaja nema zabilježen položaj pa se za nju ne mogu izračunati Sunce i Mjesec.",
  "astral.noSunriseToday": "Danas nema izlaska sunca",
  "astral.nowAtBearing": "sada {altitude} · azimut {direction}",
  "astral.observing": "Promatranje",
  "astral.ofDaylightLeft": "dnevnog svjetla preostalo",
  "astral.overTheNextThreeWeeks": "tijekom sljedeća 3 tjedna",
  "astral.percentLit": "{percent} osvijetljeno",
  "astral.polarNight": "Polarna noć",
  "astral.polarNightPeriod": "Polarna noć",
  "astral.rightNow": "Upravo sada",
  "astral.riseShort": "Izlazak",
  "astral.setShort": "Zalazak",
  "astral.shortestDay": "Najkraći dan",
  "astral.solarNoon": "Pravo podne",
  "astral.solstice": "Solsticij",
  "astral.sunBelowHorizon": "Sunce {degrees}° ispod horizonta",
  "astral.sunEvents": "Sunčevi događaji",
  "astral.sunNeverDarkEnough": "Sunce nikad ne pada 18° ispod horizonta",
  "astral.sunNeverSets": "Sunce ne zalazi",
  "astral.sunrise": "Izlazak sunca",
  "astral.sunriseAndSunset": "Izlazak i zalazak sunca",
  "astral.sunriseAt": "Izlazak sunca u {time}",
  "astral.sunset": "Zalazak sunca",
  "astral.sunsetAt": "Zalazak sunca u {time}",
  "astral.thisYearAtNorth": "Ove godine na {degrees}° sjeverne širine",
  "astral.thisYearAtSouth": "Ove godine na {degrees}° južne širine",
  "astral.tonight": "Noćas",
  "astral.twilightAllNight": "Sumrak cijelu noć — nikad potpuno mračno",
  "astral.upFor": "{duration} iznad horizonta",
  "astral.usableLight": "Iskoristivo svjetlo",
  "astral.vsAverage": "{percent} od prosjeka",
  "astral.vsYesterday": "u odnosu na jučer",
  "astral.waningCrescent": "Opadajući srp",
  "astral.waningGibbous": "Opadajući mjesec",
  "astral.waxingCrescent": "Rastući srp",
  "astral.waxingGibbous": "Rastući mjesec",
  "astral.whereToLook": "Gdje gledati",
  "astral.withoutTheMoon": "{duration} bez Mjeseca",
  "auth.alreadyHaveAccount": "Već imate račun?",
  "auth.authContainerTagline": "Vaša osobna vremenska ploča. Povežite svoje postaje i dobijte podatke u stvarnom vremenu nadohvat ruke.",
  "auth.backToLogin": "Natrag na prijavu",
  "auth.checkYourEmail": "Provjerite svoju e-poštu",
  "auth.continueWithApple": "Nastavite s Apple",
  "auth.continueWithFacebook": "Nastavite s Facebook",
  "auth.continueWithGoogle": "Nastavite s Google",
  "auth.email": "E-mail adresa",
  "auth.emailRequiredLoginFacebook": "Potrebno je dopuštenje za pristup e-mail adresi.",
  "auth.emailVerification": "Potvrda e-pošte",
  "auth.emailVerificationFailure": "Došlo je do problema sa verifikacijom putem emaila.",
  "auth.emailVerificationSuccess": "Vaša email adresa je uspješno verificirana.",
  "auth.firstName": "Ime",
  "auth.forgotPassword": "Zaboravljena lozinka?",
  "auth.forgotPasswordSubtitle": "Unesite svoju e-poštu i poslat ćemo vam vezu za poništavanje lozinke.",
  "auth.lastName": "Prezime",
  "auth.login": "Prijavi se",
  "auth.loginSubtitle": "Dobrodošli natrag! Molimo unesite svoje podatke.",
  "auth.loginToSmartMixinDescription": "Prijavite se u SmartMixin kako biste pristupili svojim meteorološkim postajama, pregledavali analize i upravljali svojom osobnom vremenskom pločom.",
  "auth.logout": "Odjavi se",
  "auth.logoutConfirmation": "Želite li se odjaviti?",
  "auth.noAccountYet": "Nemate još račun?",
  "auth.or": "ili",
  "auth.password": "Lozinka",
  "auth.passwordReset": "Ponovno postavljanje lozinke",
  "auth.passwordResetSuccess": "Vaša lozinka je uspješno promijenjena.",
  "auth.register": "Izradi račun",
  "auth.registerDescription": "Stvorite besplatni SmartMixin račun za povezivanje vaših meteoroloških postaja, praćenje vremenskih podataka i pristup naprednim analitičkim alatima.",
  "auth.registerSubtitle": "Izradite svoj račun za početak.",
  "auth.restorePassword": "Povrati lozinku",
  "auth.restorePasswordSuccess": "Upravo smo vam poslali poveznicu za ponovno postavljanje lozinke na {emailAddress} s daljnjim uputama.",
  "auth.sendReset": "Pošalji instrukcije za reset",
  "auth.signInRowDescription": "Vaša mjesta, postaje i upozorenja na svim vašim uređajima",
  "auth.signInRowTitle": "Prijavi se ili izradi račun",
  "auth.signInWithApple": "Prijava putem Applea",
  "auth.socialAccount": "ili koristite vaš račun",
  "auth.staffVerificationCode": "Kôd za potvrdu",
  "auth.staffVerificationExpiresIn": "Potvrđeno. Istječe za {duration}.",
  "auth.staffVerificationInvalidCode": "Netočan kôd. Pokušajte ponovno.",
  "auth.staffVerificationLoginAsStopped": "Login As je zaustavljen: unesite kôd za potvrdu na zaslonu Debug za nastavak.",
  "auth.staffVerificationNotEnrolled": "Za vaš račun nije postavljena aplikacija za autentifikaciju. Dodajte je u sigurnosnim postavkama administracije.",
  "auth.staffVerificationPasskey": "Potvrdi pristupnim ključem",
  "auth.staffVerificationPasskeyExpired": "Zahtjev za pristupni ključ je istekao. Pokušajte ponovno.",
  "auth.staffVerificationPasskeyFailed": "Potvrda pristupnim ključem nije uspjela. Pokušajte ponovno ili unesite kôd.",
  "auth.staffVerificationPasskeyNotEnrolled": "Na ovom telefonu nema pristupnog ključa za vaš račun. Dodajte ga s ovog telefona u sigurnosnim postavkama administracije ili unesite kôd.",
  "auth.staffVerificationPasskeySetupLink": "Dodaj pristupni ključ",
  "auth.staffVerificationPasskeyUnavailable": "Pristupni ključevi ovdje se ne mogu koristiti. Umjesto toga unesite kôd.",
  "auth.staffVerificationPrompt": "Unesite 6-znamenkasti kôd iz aplikacije za autentifikaciju ili kôd za oporavak kako biste koristili Login As i pretraživanje korisnika.",
  "auth.staffVerificationPromptPasskey": "Upotrijebite pristupni ključ ili unesite 6-znamenkasti kôd iz aplikacije za autentifikaciju ili kôd za oporavak kako biste koristili Login As i pretraživanje korisnika.",
  "auth.staffVerificationSetupLink": "Dodaj aplikaciju za autentifikaciju",
  "auth.staffVerificationSubmit": "Potvrdi",
  "auth.staffVerificationTitle": "Potvrda osoblja",
  "calendar.afternoon": "Poslijepodne",
  "calendar.april": "Travanj",
  "calendar.august": "Kolovoz",
  "calendar.changePeriod": "Razdoblje: {period}. Promijeni razdoblje",
  "calendar.currentDay": "Danas",
  "calendar.dateFormat": "Oblik datuma",
  "calendar.day": "Dan",
  "calendar.december": "Prosinac",
  "calendar.durationHours": "{hours} h",
  "calendar.durationHoursMinutes": "{hours} h {minutes} min",
  "calendar.durationMinutes": "{minutes} min",
  "calendar.durationMinutesSeconds": "{minutes} min {seconds} s",
  "calendar.durationSeconds": "{seconds} s",
  "calendar.earlierYears": "Ranije godine",
  "calendar.endTime": "Kraj",
  "calendar.evening": "Večer",
  "calendar.february": "Veljača",
  "calendar.goToNextDay": "Sljedeći dan",
  "calendar.goToNextMonth": "Sljedeći mjesec",
  "calendar.goToNextWeek": "Sljedeći tjedan",
  "calendar.goToNextYear": "Sljedeća godina",
  "calendar.goToPreviousDay": "Prethodni dan",
  "calendar.goToPreviousMonth": "Prethodni mjesec",
  "calendar.goToPreviousWeek": "Prethodni tjedan",
  "calendar.goToPreviousYear": "Prethodna godina",
  "calendar.hour": "Sat",
  "calendar.hoursCount": "{count, plural, one {# sat} few {# sata} other {# sati}}",
  "calendar.hoursShort": "h",
  "calendar.hoursShortCount": "{count, plural, one {# h} few {# h} other {# h}}",
  "calendar.january": "Siječanj",
  "calendar.july": "Srpanj",
  "calendar.june": "Lipanj",
  "calendar.last12Hours": "Posljednjih 12 sati",
  "calendar.last24Hours": "Posljednja 24 sata",
  "calendar.last24HoursTo": "24 h do {time}",
  "calendar.last24HoursToYesterday": "24 h, jučer do {time}",
  "calendar.last30Days": "Posljednjih 30 dana",
  "calendar.last3Hours": "Posljednja 3 sata",
  "calendar.last6Hours": "Posljednjih 6 sati",
  "calendar.last7Days": "Posljednjih 7 dana",
  "calendar.lastHour": "Posljednji sat",
  "calendar.laterYears": "Kasnije godine",
  "calendar.march": "Ožujak",
  "calendar.max": "Max",
  "calendar.may": "Svibanj",
  "calendar.month": "Mjesec",
  "calendar.monthTotal": "Ovaj mjesec",
  "calendar.morning": "Jutro",
  "calendar.nextHours": "Sljedeći sati",
  "calendar.night": "Noć",
  "calendar.november": "Studeni",
  "calendar.october": "Listopad",
  "calendar.oneDay": "1 dan",
  "calendar.oneHour": "1 sat",
  "calendar.oneMonth": "1 mjesec",
  "calendar.oneWeek": "1 tjedan",
  "calendar.periodRangeSpoken": "od {start} do {end}",
  "calendar.previous24Hours": "Prethodna 24 sata",
  "calendar.previous30Days": "Prethodnih 30 dana",
  "calendar.previous7Days": "Prethodnih 7 dana",
  "calendar.previousDay": "Prethodni dan",
  "calendar.previousHours": "Prethodni sati",
  "calendar.previousMonth": "Prethodni mjesec",
  "calendar.previousWeek": "Prethodni tjedan",
  "calendar.previousYear": "Prethodnu godinu",
  "calendar.sameDayLastYear": "Na isti dan prethodne godine",
  "calendar.sameMonthLastYear": "Tokom istog mjeseca prethodne godine",
  "calendar.selectADate": "Odaberite datum",
  "calendar.selectAggregation": "Odaberite prikazanu vrijednost",
  "calendar.selectAMonth": "Odaberite mjesec",
  "calendar.selectAYear": "Odaberite godinu",
  "calendar.selectGranularity": "Izaberi preciznost",
  "calendar.selectPeriod": "Odaberite razdoblje",
  "calendar.september": "Rujan",
  "calendar.sixHours": "6 sati",
  "calendar.startTime": "Početak",
  "calendar.thirtyMinutes": "30 minuta",
  "calendar.threeHours": "3 sata",
  "calendar.timezone": "Vremenska zona",
  "calendar.today": "Danas",
  "calendar.untilChanged": "Do promjene",
  "calendar.untilTime": "Do {time}",
  "calendar.untilTodayAt": "Do danas u {time}",
  "calendar.untilTomorrowAt": "Do sutra u {time}",
  "calendar.use24HourFormat": "Koristite 24-satni format",
  "calendar.week": "Tjedan",
  "calendar.year": "Godina",
  "calendar.yearToDate": "Ove godine",
  "calendar.yesterday": "Jučer",
  "charts.averageOverThePeriod": "Prosjek tokom perioda",
  "charts.calendarView": "Kalendarski pregled",
  "charts.charts": "Dijagrami",
  "charts.chartView": "Pregled dijagrama",
  "charts.comparison": "Usporedba",
  "charts.customizeComparisonMetrics": "Prilagodi mjerne podatke usporedbe",
  "charts.customizeComparisonMetricsDescription": "Povucite stavke za promjenu redoslijeda mjernih podataka usporedbe. Dodirnite ikonu oka za prikaz ili skrivanje mjernih podataka.",
  "charts.loading": "Učitavanje dijagrama",
  "charts.maxOverThePeriod": "Maksimum tokom perioda",
  "charts.measureToDisplay": "Mjera za prikaz",
  "charts.minMaxRange": "Min. / Max.",
  "charts.noDataForThisPeriod": "Nema podataka u periodu",
  "charts.observations": "Opažanja",
  "charts.observedTemperature": "Izmjerena temperatura",
  "charts.seriesTableDate": "Datum",
  "charts.showComparison": "Prikaži usporedbu",
  "charts.stationComparison": "Usporedba postaja",
  "charts.stationComparisonDescription": "Omogućuje vam usporedbu povijesnih vremenskih podataka s podacima druge postaje.",
  "charts.sumOverThePeriod": "Akumulirano tokom perioda",
  "charts.tableLabel": "Tablica: {chart}",
  "charts.toggleSeries": "Prikaži ili sakrij {series}",
  "charts.viewAsChart": "Dijagram",
  "charts.viewAsList": "Popis",
  "charts.viewAsPeriods": "Razdoblja",
  "charts.viewAsTable": "Tablica",
  "charts.viewLabel": "Prikaz: {chart}",
  "common.add": "Dodati",
  "common.altitude": "Nadmorska visina",
  "common.analysis": "Analiza",
  "common.average": "Prosjek",
  "common.back": "Natrag",
  "common.backToHome": "Natrag na početnu",
  "common.cancel": "Otkaži",
  "common.cannotBeEmpty": "Ovo polje ne može biti prazno.",
  "common.clearSearch": "Očisti pretraživanje",
  "common.close": "Zatvori",
  "common.dailyForecast": "Dnevna prognoza",
  "common.default": "Zadano",
  "common.delete": "Izbrisati",
  "common.details": "Detalji",
  "common.edit": "Uredi",
  "common.exitFullscreen": "Izađi iz cijelog zaslona",
  "common.forecast": "Prognoza",
  "common.frequency": "Frekvencija",
  "common.full": "Puna",
  "common.fullscreen": "Cijeli zaslon",
  "common.help": "Pomoć",
  "common.hidden": "Skriveno",
  "common.high": "Visoka",
  "common.iDontKnowYet": "Još ne znam",
  "common.indoor": "Unutra",
  "common.labelValue": "{label}: {value}",
  "common.lastUpdate": "Posljednje ažuriranje",
  "common.low": "Niska",
  "common.mapUnavailable": "Karta nije dostupna",
  "common.maximum": "Maksimum",
  "common.medium": "Srednja",
  "common.minimum": "Minimum",
  "common.more": "Više",
  "common.moreInformation": "Više informacija",
  "common.moveDown": "Pomakni dolje",
  "common.moveUp": "Pomakni gore",
  "common.no": "Ne",
  "common.noAccountNeeded": "Nije potreban račun",
  "common.noItemsAvailable": "Nema dostupnih stavki",
  "common.nothingSelected": "Ništa nije odabrano",
  "common.notNow": "Ne sada",
  "common.now": "Sada",
  "common.openSettings": "Otvori postavke",
  "common.outdoor": "Vani",
  "common.pageNotFound": "Stranica nije pronađena",
  "common.pageNotFoundDescription": "Stranica koju tražite ne postoji ili je premještena.",
  "common.rain": "Kiša",
  "common.reorderCancel": "Premještanje otkazano: {item}. Ponovno na položaju {position} od {count}.",
  "common.reorderEnd": "Ispušteno: {item}. Položaj {position} od {count}.",
  "common.reorderInstructions": "Da biste premjestili ovu stavku, pritisnite razmaknicu ili Enter, strelicama gore i dolje odaberite njezino mjesto, a zatim ponovno pritisnite razmaknicu ili Enter da je ispustite ili Escape za odustajanje.",
  "common.reorderOver": "{item} – sada na položaju {position} od {count}.",
  "common.reorderStart": "Podignuto: {item}. Položaj {position} od {count}.",
  "common.search": "Pretraži",
  "common.share": "Podijeli",
  "common.shareImageFailed": "Sliku nije moguće podijeliti",
  "common.shareYourWeather": "Podijelite vaše vremenske uvjete",
  "common.skip": "Preskoči",
  "common.snackbarWithAction": "{message}. Radnja: {action}",
  "common.unknown": "Nepoznat",
  "common.validate": "Potvrdi",
  "common.validEmail": "Potrebna je važeća email adresa.",
  "common.very_low": "Vrlo niska",
  "common.weatherObservations": "Promatranja vremena",
  "common.welcome": "Dobrodošli u SmartMixin!",
  "common.wind": "Vjetar",
  "common.yes": "Da",
  "common.zoomImage": "Povećaj sliku",
  "compass.E": "I",
  "compass.E_long": "Istok",
  "compass.ENE": "ISI",
  "compass.ENE_long": "Istok-sjeveroistok",
  "compass.ESE": "IJI",
  "compass.ESE_long": "Istok-jugoistok",
  "compass.N": "S",
  "compass.N_long": "Sjever",
  "compass.NE": "SI",
  "compass.NE_long": "Sjeveroistok",
  "compass.NNE": "SSI",
  "compass.NNE_long": "Sjever-sjeveroistok",
  "compass.NNW": "SSZ",
  "compass.NNW_long": "Sjever-sjeverozapad",
  "compass.NW": "SZ",
  "compass.NW_long": "Sjeverozapad",
  "compass.S": "J",
  "compass.S_long": "Jug",
  "compass.SE": "JI",
  "compass.SE_long": "Jugoistok",
  "compass.SSE": "JJI",
  "compass.SSE_long": "Jug-jugoistok",
  "compass.SSW": "JJZ",
  "compass.SSW_long": "Jug-jugozapad",
  "compass.SW": "JZ",
  "compass.SW_long": "Jugozapad",
  "compass.W": "Z",
  "compass.W_long": "Zapad",
  "compass.WNW": "ZSZ",
  "compass.WNW_long": "Zapad-sjeverozapad",
  "compass.WSW": "ZJZ",
  "compass.WSW_long": "Zapad-jugozapad",
  "dashboard.currentObservations": "Trenutne vrijednosti",
  "dashboard.currentRainEvent": "Trenutačni kišni događaj",
  "dashboard.currentWeatherConditions": "Trenutačno vrijeme",
  "dashboard.customizeDashboard": "Prilagodi",
  "dashboard.customizeDashboardDescription": "Povucite stavke za promjenu redoslijeda na nadzornoj ploči. Dodirnite ikonu oka za prikaz ili skrivanje odjeljaka.",
  "dashboard.customizeNetatmoDescription": "Povucite module kako biste promijenili njihov redoslijed unutar odjeljka Vani ili Unutra. Dodirnite ikonu oka za prikaz ili skrivanje modula.",
  "dashboard.customizeNetatmoPublicDescription": "Povucite module kako biste promijenili njihov redoslijed. Dodirnite ikonu oka za prikaz ili skrivanje modula.",
  "dashboard.dashboard": "Nadzorna ploča",
  "dashboard.dayRangeExpected": "{value} očekuje se u {time}",
  "dashboard.dayRangeReached": "{value} u {time}",
  "dashboard.dayRangeSteady": "Stabilno {value} cijeli dan",
  "dashboard.hiddenSensors": "Skriveni senzori",
  "dashboard.hideSensor": "Sakrij {sensor}",
  "dashboard.lastRainEvent": "Zadnji kišni događaj",
  "dashboard.lastVisibleSensor": "Barem jedan senzor mora ostati vidljiv.",
  "dashboard.manageSensors": "Upravljanje senzorima",
  "dashboard.manageSensorsDescription": "Povucite stavke za promjenu redoslijeda senzora. Dodirnite ikonu oka za prikaz ili skrivanje senzora. Dodirnite naziv za preimenovanje.",
  "dashboard.manageSensorsDescriptionWeb": "Kliknite olovku za preimenovanje senzora, povucite ručku za promjenu redoslijeda popisa i kliknite oko da biste ga sakrili ili prikazali.",
  "dashboard.moveSensor": "Premjesti {sensor}",
  "dashboard.pressureSummary": "Sažetak tlaka",
  "dashboard.rainEvents": "Kišni događaji",
  "dashboard.rainSummary": "Sažetak padalina",
  "dashboard.renameSensor": "Preimenuj {sensor}",
  "dashboard.shareOutdoorMeasures": "Podijelite vaša vanjska mjerenja",
  "dashboard.shareOutdoorMeasuresDescription": "Učestvujte u zajednici korisnika aplikacije SmartMixin tako što ćete dijeliti mjerenja sa vašeg vanjskog modula. Mjerenja sa unutrašnjeg modula nikada neće biti dijeljena.",
  "dashboard.showSensor": "Prikaži {sensor}",
  "dashboard.temperatureSummary": "Sažetak temperature",
  "dashboard.useDefaultSensorName": "Koristi zadani naziv",
  "dashboard.windSummary": "Sažetak vjetra",
  "devices.batteryLevel": "Razina baterije",
  "devices.firmwareVersion": "Verzija firmwarea",
  "devices.moduleCount": "{count, plural, one {# modul} few {# modula} other {# modula}}",
  "devices.moduleType": "Tip modula",
  "devices.noNetatmoWeatherStationYet": "Još nemate Netatmo meteorološku postaju.",
  "devices.noOutdoorModule": "Nije otkriven niti jedan vanjski modul za ovu postaju.",
  "devices.notReachable": "Nedostupan",
  "devices.serialNumber": "Serijski broj",
  "devices.signalAverage": "Umjeren",
  "devices.signalBad": "Slab",
  "devices.signalGood": "Dobar",
  "devices.signalStrength": "Jačina signala",
  "devices.signalUnknown": "Nepoznat",
  "devices.visitNetatmoWebsite": "Posjetite stranicu Netatmo",
  "devices.wifiStrength": "Jačina Wi-Fi signala",
  "forecastMaps.addColor": "Dodaj boju",
  "forecastMaps.addLayer": "Dodaj sloj",
  "forecastMaps.autoDescription": "Najbolji dostupan za ovaj prikaz",
  "forecastMaps.autoDescriptionFree": "Bez Premium: {model}",
  "forecastMaps.autoPreview": "Auto",
  "forecastMaps.autoSwitched": "Sada {model}: {previous} pokriva {coverage, number, percent} ovog prikaza",
  "forecastMaps.backToMaps": "Natrag na karte",
  "forecastMaps.build": "Generiraj",
  "forecastMaps.buildCompleted": "Generiranje dovršeno",
  "forecastMaps.builderMetaDescription": "Sastavite vlastite prognostičke karte od slojeva meteoroloških modela.",
  "forecastMaps.builderTitle": "Izrada karata",
  "forecastMaps.buildFailed": "Generiranje nije uspjelo. Pokušajte ponovno.",
  "forecastMaps.buildNotPossible": "Ova se karta još ne može generirati — nema dostupnih prognostičkih podataka.",
  "forecastMaps.buildProgress": "Iscrtavanje… {completed}/{total} koraka",
  "forecastMaps.buildStarting": "Pokretanje generiranja…",
  "forecastMaps.byModel": "Po modelu",
  "forecastMaps.byZone": "Po zoni",
  "forecastMaps.colormap": "Paleta boja",
  "forecastMaps.colormapCustom": "Prilagođene boje",
  "forecastMaps.colormapGroupDomain": "Meteorološki predlošci",
  "forecastMaps.colormapGroupMatplotlib": "Znanstveni predlošci",
  "forecastMaps.colorStop": "Boja {position}",
  "forecastMaps.configUnavailable": "Ova prognostička karta nije dostupna. Umjesto nje prikazuje se {name}.",
  "forecastMaps.contourLevels": "Razine izolinija",
  "forecastMaps.countryCanada": "Kanada",
  "forecastMaps.countryFrance": "Francuska",
  "forecastMaps.countryGermany": "Njemačka",
  "forecastMaps.countryItaly": "Italija",
  "forecastMaps.countryScandinavia": "Skandinavija",
  "forecastMaps.countrySpain": "Španjolska",
  "forecastMaps.countrySwitzerland": "Švicarska",
  "forecastMaps.countryUnitedStates": "Sjedinjene Države",
  "forecastMaps.coverageUnknown": "Područje nepoznato",
  "forecastMaps.coversView": "Pokriva {coverage, number, percent} ovog prikaza",
  "forecastMaps.customColormapMinColors": "Prilagođena paleta boja zahtijeva najmanje dvije boje",
  "forecastMaps.customExtent": "Prilagođeni obuhvat",
  "forecastMaps.displayName": "Prikazani naziv",
  "forecastMaps.downscaling": "Faktor prorjeđivanja strelica vjetra",
  "forecastMaps.dpi": "DPI",
  "forecastMaps.drawArea": "Nacrtaj područje",
  "forecastMaps.east": "Istok",
  "forecastMaps.extentDrawHint": "Povucite po karti da biste nacrtali područje",
  "forecastMaps.extentInvalid": "Zapad mora biti manji od istoka, a jug manji od sjevera",
  "forecastMaps.frameTime": "Vrijeme prognoze",
  "forecastMaps.height": "Visina (inči)",
  "forecastMaps.hourOffset": "+{hour} h",
  "forecastMaps.inThisArea": "U ovom području",
  "forecastMaps.invalidHexColor": "Nevažeća boja — koristite #RRGGBB",
  "forecastMaps.layerHasErrors": "Ovaj sloj sadrži pogreške",
  "forecastMaps.layers": "Slojevi",
  "forecastMaps.layerTypeBarbs": "Strelice vjetra",
  "forecastMaps.layerTypeContour": "Izolinije",
  "forecastMaps.layerTypeFilledContour": "Ispunjene izolinije",
  "forecastMaps.layerTypeMagnitude": "Magnituda",
  "forecastMaps.layerTypeRaster": "Raster",
  "forecastMaps.layerTypeVectorField": "Vektorsko polje",
  "forecastMaps.leave": "Izađi",
  "forecastMaps.levelsCount": "Broj",
  "forecastMaps.levelsInvalid": "Nevažeće razine izolinija",
  "forecastMaps.levelsModeArange": "Fiksni korak",
  "forecastMaps.levelsModeExplicit": "Eksplicitne vrijednosti",
  "forecastMaps.levelsModeLinspace": "Ravnomjerno raspoređeno (broj)",
  "forecastMaps.levelsStep": "Korak",
  "forecastMaps.levelsValues": "Vrijednosti",
  "forecastMaps.levelsValuesHint": "Odvojene zarezima, uzlazno",
  "forecastMaps.loadingMaps": "Učitavanje karata…",
  "forecastMaps.localTimeHint": "Prikazano u vašem lokalnom vremenu",
  "forecastMaps.lockedConfig": "{model} je Premium model. Umjesto njega prikazuje se {fallback}.",
  "forecastMaps.lockedVariable": "{variable}, Premium",
  "forecastMaps.mapDescription": "Opis",
  "forecastMaps.mapName": "Naziv karte",
  "forecastMaps.mapNameRequired": "Unesite naziv",
  "forecastMaps.mapSettings": "Postavke karte",
  "forecastMaps.maxLayersReached": "Ova je karta dosegla maksimum od {max} slojeva.",
  "forecastMaps.maxValue": "Maksimalna vrijednost",
  "forecastMaps.memoryBudgetExceeded": "Razlučivost premašuje proračun iscrtavanja — smanjite DPI ili visinu",
  "forecastMaps.memoryBudgetUsage": "Proračun iscrtavanja: {percent}%",
  "forecastMaps.metaDescription": "Animirane prognostičke karte izrađene iz izračuna meteoroloških modela.",
  "forecastMaps.metric": "Veličina",
  "forecastMaps.metricRequired": "Odaberite veličinu",
  "forecastMaps.metricUnavailable": "Nije dostupno za ovaj model",
  "forecastMaps.minBelowMax": "Minimum mora biti manji od maksimuma",
  "forecastMaps.minMaxRequired": "Minimalna i maksimalna vrijednost obavezne su za ovu vrstu sloja",
  "forecastMaps.minValue": "Minimalna vrijednost",
  "forecastMaps.modelChipAuto": "Auto · {model}",
  "forecastMaps.modelCoversView": "{model} pokriva {coverage, number, percent} ovog prikaza",
  "forecastMaps.modelNoRun": "Još nema dovršenog izračuna",
  "forecastMaps.modelOption": "{model}, {grid}",
  "forecastMaps.nanClipToMin": "Ograniči na minimum",
  "forecastMaps.nanMask": "Maskiraj",
  "forecastMaps.nanPolicy": "Nedostajući podaci",
  "forecastMaps.nanSkip": "Preskoči",
  "forecastMaps.noCompletedRun": "Ova karta još nije izrađena. Provjerite ponovno uskoro.",
  "forecastMaps.noLayers": "Još nema slojeva. Dodajte sloj za početak.",
  "forecastMaps.noMapsAvailable": "Prognostičke karte još nisu dostupne.",
  "forecastMaps.north": "Sjever",
  "forecastMaps.opacity": "Neprozirnost",
  "forecastMaps.openAsAnimation": "Otvori kao animaciju",
  "forecastMaps.otherAreas": "Druga područja",
  "forecastMaps.outsideArea": "Ne pokriva ovo područje",
  "forecastMaps.overlayLegend": "Legenda",
  "forecastMaps.pause": "Pauza",
  "forecastMaps.play": "Reproduciraj",
  "forecastMaps.pointValueAnnouncement": "{value}, {time}",
  "forecastMaps.pointValueError": "Prognozu za ovu točku nije moguće učitati.",
  "forecastMaps.pointValueLoading": "Učitavanje prognoze…",
  "forecastMaps.pointValueUnavailable": "Nema podataka za ovo vrijeme.",
  "forecastMaps.premiumModelForView": "{model} pokriva ovaj prikaz",
  "forecastMaps.premiumRequired": "Prognostičke karte zahtijevaju Premium",
  "forecastMaps.preview": "Pretpregled",
  "forecastMaps.previewEmptyHint": "Postavite barem jedan valjan sloj za iscrtavanje pretpregleda.",
  "forecastMaps.previewFailed": "Pretpregled nije uspio",
  "forecastMaps.previewHour": "Sat prognoze",
  "forecastMaps.previewRendering": "Iscrtavanje pretpregleda…",
  "forecastMaps.projection": "Projekcija",
  "forecastMaps.projectionLambertConformal": "Lambertova konformna",
  "forecastMaps.projectionMercator": "Mercatorova",
  "forecastMaps.projectionPlateCarree": "Plate carrée",
  "forecastMaps.projectionStereographic": "Stereografska",
  "forecastMaps.regionEurope": "Europa",
  "forecastMaps.regionNorthAmerica": "Sjeverna Amerika",
  "forecastMaps.removeColor": "Ukloni boju",
  "forecastMaps.removeLayer": "Ukloni sloj",
  "forecastMaps.retry": "Pokušaj ponovno",
  "forecastMaps.run": "Izračun: {run}",
  "forecastMaps.runNotDisplayable": "Ovaj izračun ne može se prikazati na interaktivnoj karti.",
  "forecastMaps.save": "Spremi",
  "forecastMaps.selectExtentOnMap": "Odaberi područje na karti",
  "forecastMaps.showArea": "Prikaži područje",
  "forecastMaps.showAreaOf": "Prikaži područje, {model}",
  "forecastMaps.south": "Jug",
  "forecastMaps.switchToModel": "Prebaci na {model}",
  "forecastMaps.title": "Prognostičke karte",
  "forecastMaps.uMetric": "U-komponenta",
  "forecastMaps.unitConversion": "Pretvorba jedinica",
  "forecastMaps.unitNone": "Bez pretvorbe",
  "forecastMaps.unsavedChangesBody": "Imate nespremljene promjene. Izaći i odbaciti ih?",
  "forecastMaps.unsavedChangesTitle": "Nespremljene promjene",
  "forecastMaps.useCurrentView": "Koristi trenutačni prikaz",
  "forecastMaps.useModelDomain": "Isključeno: koristi se cijela domena modela",
  "forecastMaps.utcTime": "UTC: {time}",
  "forecastMaps.uvMetricsDiffer": "Veličine U i V moraju se razlikovati",
  "forecastMaps.valueBetween": "Mora biti između {min} i {max}",
  "forecastMaps.variable": "Varijabla",
  "forecastMaps.variableMissing": "{variable}: nema podataka",
  "forecastMaps.variableOnlyFrom": "{variable}: samo iz modela {model}",
  "forecastMaps.vectorLayerFronts": "Fronte",
  "forecastMaps.vectorLayerIsobars": "Izobare",
  "forecastMaps.vectorLayerWindBarbs": "Strelice vjetra",
  "forecastMaps.viewMap": "Prikaži kartu",
  "forecastMaps.vMetric": "V-komponenta",
  "forecastMaps.west": "Zapad",
  "forecastMaps.windAnimation": "Animacija vjetra",
  "forecastMaps.windAnimationReduceMotion": "Isključena dok je na vašem uređaju uključeno smanjenje kretanja",
  "forecastModels.addForecastModel": "Dodaj model",
  "forecastModels.atYourStations": "Dostupni na vašim postajama",
  "forecastModels.comparisonLoadError": "Učitavanje usporedbe vremenskih modela nije uspjelo",
  "forecastModels.coverageLoading": "Utvrđujemo koje vaše postaje pokriva svaki model…",
  "forecastModels.description_AROME": "Visokorezolucijski model Météo Francea koji omogućava razlučivanje konvekcije nad zapadnom Europom s rezolucijom od 1,3 km. Najbolji u klasi za kratkoročne prognoze u Francuskoj; ažurira se svaka tri sata.",
  "forecastModels.description_ARPEGE_EU": "Europska ugniježđena domena modela ARPEGE Météo Francea s rezolucijom od 10 km. Srednjoročne prognoze nad Europom, ažuriraju se četiri puta dnevno.",
  "forecastModels.description_ARPEGE_GLOBAL": "Globalni numerički model vremena Météo Francea s rezolucijom od 25 km, do otprilike 4 dana. Ažurira se četiri puta dnevno.",
  "forecastModels.description_DMI_DINI": "HARMONIE DINI tvrtke DMI: model koji omogućuje razlučivanje konvekcije nad sjeverozapadnom Europom — Danska, Beneluks, Irska, Ujedinjeno Kraljevstvo i Skandinavija — s rezolucijom od 2 km koji ide do 60 sati, ažurira se osam puta dnevno. Sadrži izmijenjene otvorene podatke DMI-ja (CC BY 4.0).",
  "forecastModels.description_EC_GDPS": "Global Deterministic Prediction System (globalni deterministički sustav predviđanja) agencije Environment Canada: svjetski srednjoročni model s rezolucijom od 15 km koji ide do 10 dana, ažurira se dva puta dnevno.",
  "forecastModels.description_EC_HRDPS": "High Resolution Deterministic Prediction System (deterministički sustav predviđanja visoke rezolucije) agencije Environment Canada: model koji omogućuje razlučivanje konvekcije nad Kanadom i sjevernim dijelom Sjedinjenih Država s rezolucijom od 2,5 km koji ide do 48 sati, ažurira se četiri puta dnevno.",
  "forecastModels.description_EC_RDPS": "Regional Deterministic Prediction System (regionalni deterministički sustav predviđanja) agencije Environment Canada: srednjoročni model nad Sjevernom Amerikom s rezolucijom od 10 km, ažurira se četiri puta dnevno.",
  "forecastModels.description_ECMWF_HRES": "Vodeći model visoke rezolucije (IFS) Europskog centra za srednjoročne vremenske prognoze, široko smatran najboljim globalnim prognostičkim sustavom na svijetu. Pokriva cijeli planet rezolucijom od 25 km do 15 dana, ažurira se četiri puta dnevno. Sadrži izmijenjene otvorene podatke ECMWF-a (CC BY 4.0).",
  "forecastModels.description_GFS": "NOAA-in vodeći srednjoročni globalni model. Pokriva cijeli planet s rezolucijom od 25 km do 16 dana, ažurira se četiri puta dnevno.",
  "forecastModels.description_HRRR_CONUS": "NOAA-in High-Resolution Rapid Refresh: model koji omogućava razlučivanje konvekcije nad kontinentalnim SAD-om s rezolucijom od 3 km, ažurira se svaki sat. Najprikladniji za vrlo kratkoročne prognoze grmljavinskih oluja i jakog vremena.",
  "forecastModels.description_ICON": "DWD-ov globalni model ICON razlučivosti 13 km koji pokriva cijeli planet do 7,5 dana, ažurira se četiri puta dnevno. Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_ICON_2I": "ICON-2I agencije ItaliaMeteo, koji se izvodi zajedno s ARPAE: model koji omogućuje razlučivanje konvekcije nad Italijom s rezolucijom od 2,2 km koji ide do 72 sata, ažurira se dvaput dnevno. Sadrži otvorene podatke ItaliaMeteo (CC BY 4.0).",
  "forecastModels.description_ICON_CH1": "Kontrolno izvođenje modela ICON-CH1-EPS agencije MeteoSwiss: model koji omogućuje razlučivanje konvekcije nad Alpama s rezolucijom od 1 km koji ide do 33 sata, ažurira se svaka tri sata.",
  "forecastModels.description_ICON_CH2": "Kontrolno izvođenje modela ICON-CH2-EPS agencije MeteoSwiss: model koji omogućuje razlučivanje konvekcije nad Alpama — Švicarska i okolna alpska regija — s rezolucijom od 2,1 km koji ide do 120 sati, ažurira se četiri puta dnevno.",
  "forecastModels.description_ICON_DE": "Visokorezolucijski model DWD-a koji omogućava razlučivanje konvekcije nad Njemačkom i susjednim zemljama s rezolucijom od 2,2 km. Kratkoročne prognoze ažuriraju se dva puta dnevno. Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_ICON_EU": "Europska ugniježđena domena modela ICON DWD-a s rezolucijom od 7 km koja pokriva Europu i Sjeverni Atlantik. Srednjoročne prognoze ažuriraju se četiri puta dnevno. Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_MET_NORWAY": "Otvorena usluga prognoze vremena Norveškog meteorološkog instituta, koja kombinira visokorezolucijske nordijske modele s podacima ECMWF-a za pružanje globalnih prognoza do 10 dana unaprijed.",
  "forecastModels.description_MF_AROME_ANTILLES": "Ugniježđena domena AROME nad francuskim Antilima (Guadeloupe, Martinique) s rezolucijom od 2,5 km. Kratkoročne prognoze ažuriraju se četiri puta dnevno.",
  "forecastModels.description_MF_AROME_GUYANE": "Ugniježđena domena AROME nad Francuskom Gvajanom s rezolucijom od 2,5 km. Kratkoročne prognoze ažuriraju se četiri puta dnevno.",
  "forecastModels.description_MF_AROME_NOUVELLE_CALEDONIE": "Ugniježđena domena AROME nad Novom Kaledonijom s rezolucijom od 2,5 km. Kratkoročne prognoze ažuriraju se četiri puta dnevno.",
  "forecastModels.description_MF_AROME_POLYNESIE": "Ugniježđena domena AROME nad Francuskom Polinezijom s rezolucijom od 2,5 km. Kratkoročne prognoze ažuriraju se četiri puta dnevno.",
  "forecastModels.description_MF_AROME_REUNION_MAYOTTE": "Ugniježđena domena AROME nad Réunionom i Mayotteom s rezolucijom od 2,5 km. Kratkoročne prognoze ažuriraju se četiri puta dnevno.",
  "forecastModels.description_RRFS_CONUS": "NOAA-in sustav Rapid Refresh Forecast nad kontinentalnim SAD-om razlučivosti 3 km. Satne prognoze osvježavaju se osam puta dnevno, do 84 sata u četiri glavna prolaza i 18 sati u ostalima.",
  "forecastModels.description_RRFS_NORTH_AMERICA": "NOAA-in sustav Rapid Refresh Forecast koji pokriva cijelu Sjevernu Ameriku razlučivosti 13 km. Satne prognoze do 84 sata, osvježavaju se četiri puta dnevno.",
  "forecastModels.description_SMARTMIXIN_MULTIMODEL": "Vodeća prognoza SmartMixina. Za svaki sat na vašoj lokaciji biramo najbolji dostupan model — obično visokorezolucijski regionalni model gdje takav postoji (AROME u Francuskoj, ICON-D2 u Njemačkoj, HRRR u SAD-u, ARPEGE Europe na cijelom kontinentu…) i vraćamo se na globalni model drugdje — zatim popunjavamo sve praznine iz susjednih izvora. Rezultat je jedna besprijekorna prognoza koja pokriva bilo gdje u svijetu do 14 dana, automatski se ažurira svaki put kada se ažurira bilo koji od osnovnih modela.",
  "forecastModels.description_WEATHERFLOW_FORECAST": "Vlasnička globalna prognoza Weatherflowa koja spaja više numeričkih modela vremena s opažanjima iz njegove mreže Tempest meteoroloških postaja. Svjetski horizont od 10 dana.",
  "forecastModels.everywhereElse": "Svugdje drugdje",
  "forecastModels.everywhereElseFoot": "Koristi se na svakoj postaji do koje vaši preferirani modeli ne dosežu.",
  "forecastModels.everywhereElsePick": "Odaberite jedan",
  "forecastModels.fallbackBlend": "SmartMixin mješavina",
  "forecastModels.fallbackBlendSub": "Kombinira više modela, svaki ondje gdje je najjači.",
  "forecastModels.fallbackEcmwf": "ECMWF",
  "forecastModels.fallbackEcmwfSub": "ECMWF HRES svugdje gdje doseže.",
  "forecastModels.fallbackGfs": "GFS",
  "forecastModels.fallbackGfsSub": "NOAA-in globalni model. Ono što danas koristi svaki račun.",
  "forecastModels.fallbackResolution": "Najviša razlučivost",
  "forecastModels.fallbackResolutionSub": "Najfinija mreža na svakoj postaji, ali GDPS dolazi iza modela ECMWF i GFS.",
  "forecastModels.forecastChipLabelWithRun": "{model}, izračun {run}",
  "forecastModels.forecastChipRunHint": "Dugo pritisnite za prikaz ili skrivanje najnovijeg izračuna",
  "forecastModels.forecastComparisonDescription": "Jednostavno usporedite podatke iz različitih dostupnih vremenskih modela",
  "forecastModels.forecastFollowingPreferences": "Prema vašim preferencijama",
  "forecastModels.forecastLoadError": "Učitavanje prognoze nije uspjelo",
  "forecastModels.forecastModel": "Prognostički model",
  "forecastModels.forecastModelAbout": "O modelu {model}",
  "forecastModels.forecastModelComparison": "Usporedba vremenskih modela",
  "forecastModels.forecastModelCoverage": "Pokrivenost",
  "forecastModels.forecastModelDescription": "Opis",
  "forecastModels.forecastModels": "Modeli prognoze",
  "forecastModels.forecastModelScopeGlobal": "Globalni",
  "forecastModels.forecastModelScopeGlobalDescription": "Ovaj model pokriva cijeli planet.",
  "forecastModels.forecastModelScopeRegional": "Regionalni",
  "forecastModels.forecastModelScopeRegionalDescription": "Ovaj model pokriva samo određenu regiju.",
  "forecastModels.forecastModelSpecifications": "Specifikacije",
  "forecastModels.forecastNoPinLocation": "Nijedan preferirani model ne doseže ovu lokaciju — odlučuje „svugdje drugdje”.",
  "forecastModels.forecastNoPinStation": "Nijedan preferirani model ne doseže ovu postaju — odlučuje „svugdje drugdje”.",
  "forecastModels.forecastNoPreferredModels": "Još nema postavljenih preferiranih modela.",
  "forecastModels.forecastOverrideElsewhere": "Vaše preferencije vrijede svugdje drugdje.",
  "forecastModels.forecastPickForLocation": "Ili odaberite jedan za ovu lokaciju",
  "forecastModels.forecastPickForStation": "Ili odaberite jedan za ovu postaju",
  "forecastModels.forecastPinWinsLocation": "{model} — vaš prvi preferirani model koji doseže ovu lokaciju.",
  "forecastModels.forecastPinWinsStation": "{model} — vaš prvi preferirani model koji doseže ovu postaju.",
  "forecastModels.forecastServedNowHere": "Trenutačno je ovdje {model}",
  "forecastModels.forecastSetForLocation": "Postavljeno za ovu lokaciju",
  "forecastModels.forecastSetForStation": "Postavljeno za ovu postaju",
  "forecastModels.forecastSettingsRowSub": "Preferirani modeli i što vrijedi svugdje drugdje",
  "forecastModels.forecastStopUsingHere": "Prestani koristiti ovdje",
  "forecastModels.forecastUseForLocation": "Koristi {model} za ovu lokaciju",
  "forecastModels.forecastUseForStation": "Koristi {model} za ovu postaju",
  "forecastModels.forecastUsePreferred": "Koristi moje preferirane modele",
  "forecastModels.frequencyHourly": "Svaki sat",
  "forecastModels.horizon": "Horizont",
  "forecastModels.horizonValue": "do {value} sati",
  "forecastModels.meshSize": "Veličina mreže",
  "forecastModels.pickerShowAll": "Prikaži cijeli katalog",
  "forecastModels.pickerUnreachable": "{count, plural, one {# dodatni model ne doseže} few {# dodatna modela ne dosežu} other {# dodatnih modela ne doseže}} nijednu vašu postaju",
  "forecastModels.pinInUse": "U upotrebi",
  "forecastModels.pinShadowed": "Nikad se ne koristi — model iznad pokriva sve vaše postaje",
  "forecastModels.pinSlots": "{used} od {max} · odaberite model",
  "forecastModels.pinSlotsFull": "{max, plural, =1 {Jedino mjesto je zauzeto. Uklonite njegov model da biste dodali drugi.} one {Sva mjesta (#) su zauzeta. Uklonite jedno da biste dodali drugo.} few {Sva # mjesta su zauzeta. Uklonite jedno da biste dodali drugo.} other {Svih # mjesta je zauzeto. Uklonite jedno da biste dodali drugo.}}",
  "forecastModels.pinsUncoveredCount": "{used} od vaših {count, plural, one {# postaje} few {# postaje} other {# postaja}}: nijedan preferirani model ne doseže do {used, plural, =1 {nje} other {njih}} — odlučuje „svugdje drugdje”.",
  "forecastModels.pinsUncoveredNamed": "{stations}: nijedan preferirani model ne doseže do {count, plural, one {nje} other {njih}} — odlučuje „svugdje drugdje”.",
  "forecastModels.pinUnreachable": "Nikad se ne koristi — ne doseže nijednu vašu postaju",
  "forecastModels.pinUsedAt": "Koristi se na {stations}",
  "forecastModels.pinUsedAtAll": "{count, plural, =1 {Koristi se na vašoj postaji} other {Koristi se na svim postajama (#)}}",
  "forecastModels.pinUsedAtSome": "Koristi se na {used} od {count, plural, one {# postaje} few {# postaje} other {# postaja}}",
  "forecastModels.preferredModels": "Preferirani modeli",
  "forecastModels.preferredModelsAll": "Jedan popis, sve postaje",
  "forecastModels.preferredModelsOne": "Jedan popis, vrijedi svugdje",
  "forecastModels.publisher": "Izdavač",
  "forecastModels.removePreferredModel": "Ukloni {model} iz preferiranih modela",
  "forecastModels.resetForecastPreference": "Vrati zadano",
  "forecastModels.resetForecastPreferenceHint": "Briše vaše preferirane modele i vraća zadanu postavku SmartMixina.",
  "forecastModels.servedNowMany": "Upravo sada: GFS {count, plural, =1 {na vašoj postaji} other {na svim vašim postajama (#)}}.",
  "forecastModels.servedNowNone": "Upravo sada: GFS svugdje.",
  "forecastModels.title_SMARTMIXIN_MULTIMODEL": "SmartMixin multimodel",
  "forecastModels.title_WEATHERFLOW_FORECAST": "Weatherflow prognoza",
  "forecastModels.weatherForecastModels": "Modeli vremenske prognoze",
  "helpCenter.articleCount": "{count, plural, one {# članak} few {# članka} other {# članaka}}",
  "helpCenter.articleNotFound": "Članak nije pronađen",
  "helpCenter.articleNotFoundDescription": "Članak koji tražite ne postoji.",
  "helpCenter.backToHelpCenter": "Natrag u centar za pomoć",
  "helpCenter.browseByCategory": "Pregledaj po kategoriji",
  "helpCenter.categoryNotFound": "Kategorija nije pronađena",
  "helpCenter.categoryNotFoundDescription": "Ova kategorija ne postoji ili nema članaka.",
  "helpCenter.contactSupport": "Kontaktirajte podršku",
  "helpCenter.feedbackHelpsImprove": "Vaše povratne informacije pomažu nam poboljšati članke pomoći.",
  "helpCenter.feedbackReasonNotAnswer": "Ne odgovara na moje pitanje",
  "helpCenter.feedbackReasonOutdated": "Informacije su zastarjele",
  "helpCenter.feedbackReasonUnclear": "Upute su nejasne",
  "helpCenter.feedbackWhatWentWrong": "U čemu je bio problem?",
  "helpCenter.helpCategoryAccount": "Račun",
  "helpCenter.helpCategoryBilling": "Naplata",
  "helpCenter.helpCategoryForecast": "Prognoze",
  "helpCenter.helpCategoryGettingStarted": "Prvi koraci",
  "helpCenter.helpCategoryProviders": "Pružatelji",
  "helpCenter.helpCategoryStations": "Postaje",
  "helpCenter.helpCategoryTroubleshooting": "Rješavanje problema",
  "helpCenter.helpCenter": "Centar za pomoć",
  "helpCenter.landingDescription": "Pronađite odgovore na česta pitanja i saznajte kako izvući najbolje iz SmartMixina.",
  "helpCenter.linkToSection": "Poveznica na ovaj odjeljak",
  "helpCenter.menuItemDescription": "Često postavljana pitanja i vodiči",
  "helpCenter.minRead": "{minutes} min čitanja",
  "helpCenter.onThisPage": "Na ovoj stranici",
  "helpCenter.platformMobileApp": "Mobilna aplikacija",
  "helpCenter.platformMobileOnly": "Samo u mobilnoj aplikaciji",
  "helpCenter.platformWebApp": "Web-aplikacija",
  "helpCenter.platformWebOnly": "Samo u web-aplikaciji",
  "helpCenter.popularArticles": "Popularni članci",
  "helpCenter.relatedArticles": "Povezani članci",
  "helpCenter.searchArticles": "Pretraži članke...",
  "helpCenter.stillNeedHelp": "Još uvijek trebate pomoć?",
  "helpCenter.stillNeedHelpDescription": "Ako ovaj članak nije odgovorio na vaše pitanje, rado ću vam pomoći izravno.",
  "helpCenter.supportEmailSubject": "SmartMixin pomoć",
  "helpCenter.supportEmailSubjectTopic": "SmartMixin pomoć — {topic}",
  "helpCenter.thankYouForFeedback": "Hvala na povratnoj informaciji!",
  "helpCenter.wasArticleHelpful": "Je li vam ovaj članak bio koristan?",
  "intro.allowLocation": "Dopusti lokaciju",
  "intro.alreadyHaveAccount": "Već imate račun?",
  "intro.connectStationDescription": "Odaberite svoju uslugu. Prijavit ćete se kako biste je povezali.",
  "intro.connectStationTitle": "Povežite svoju postaju",
  "intro.haveWeatherStation": "Imam meteorološku postaju",
  "intro.locationDescription": "Omogućite pristup lokaciji za točne vremenske prognoze prilagođene vašem točnom području — bez univerzalnih prognoza.",
  "intro.locationTitle": "Prognoze izrađene za vas",
  "intro.showWeatherHere": "Prikaži vrijeme na mojoj lokaciji",
  "intro.showWeatherInstead": "Ne sada, prikaži mi vrijeme",
  "intro.welcomeDescription": "Dobijte hiperlokalne prognoze od najboljih meteoroloških agencija — plus pristup više od 40.000 meteoroloških postaja diljem svijeta za stvarne uvjete, prošle i sadašnje.",
  "intro.welcomeTitle": "Vaša vremenska prognoza, ponovno osmišljena",
  "landing.alsoAvailableOn": "Dostupno i na:",
  "landing.featureAlertsDescription": "Postavite prilagođene pragove za bilo koju mjernu veličinu. Primajte obavijesti kada temperatura padne, počne kiša ili se vjetar pojača.",
  "landing.featureAlertsTitle": "Pametna upozorenja",
  "landing.featureAnalyticsDescription": "Interaktivni grafikoni, analiza trendova i detaljna statistika. Uronite u podatke o temperaturi, vlažnosti, tlaku, kiši i vjetru.",
  "landing.featureAnalyticsTitle": "Napredna analitika",
  "landing.featureExportDescription": "Primite sve svoje vremenske podatke e-poštom kao Excel tablicu, spremnu za daljnju analizu u Excelu, Google tablicama ili omiljenim alatima.",
  "landing.featureExportTitle": "Izvezite svoje podatke",
  "landing.featureForecastDescription": "Pristupite {count, plural, one {#+ profesionalnom prognostičkom modelu} few {#+ profesionalna prognostička modela} other {#+ profesionalnih prognostičkih modela}}, uključujući ECMWF, GFS i regionalne modele. Usporedite ih jedan uz drugi i napravite vlastite prognoze.",
  "landing.featureForecastTitle": "Usporedite prognostičke modele",
  "landing.featureHistoryDescription": "Pristup povijesnim podacima sa satnom, dnevnom i mjesečnom skalom. Izvezite ih u Excel za istraživanje ili osobne arhive.",
  "landing.featureHistoryTitle": "Bogata povijest",
  "landing.featureMultiBrandDescription": "Povežite Netatmo, Davis, Tempest, Ecowitt, Ambient Weather i druge. Nema više prebacivanja između aplikacija.",
  "landing.featureMultiBrandTitle": "Sve marke, jedna aplikacija",
  "landing.featuresSubtitle": "SmartMixin vam daje alate da analizirate, uspoređujete i razumijete svoje vremenske podatke poput profesionalca.",
  "landing.featuresTitle": "Stvoreno za ljubitelje podataka",
  "landing.finalCtaButton": "Stvorite besplatan račun",
  "landing.finalCtaSubtitle": "Pridružite se tisućama ljubitelja vremena koji vjeruju SmartMixinu.",
  "landing.finalCtaTitle": "Spremni zaroniti dublje u svoje vremenske podatke?",
  "landing.heroCta": "Započnite besplatno",
  "landing.heroDescription": "Dubinska analitika, lijepi grafikoni i profesionalne prognoze — sve vaše meteorološke postaje objedinjene u jednoj moćnoj aplikaciji.",
  "landing.heroSecondaryCta": "Istražite kartu",
  "landing.heroTagline": "Za ljubitelje vremena",
  "landing.heroTitle": "Pogledajte vrijeme kao nikad prije",
  "landing.pricingComparisonCaption": "Usporedba značajki besplatnog plana i plana Premium",
  "landing.pricingFeatureAdvancedMetrics": "Napredne metrike",
  "landing.pricingFeatureAlerts": "Prilagođena upozorenja",
  "landing.pricingFeatureColumn": "Značajka",
  "landing.pricingFeatureExport": "Izvoz podataka (Excel)",
  "landing.pricingFeatureForecastComparison": "Usporedba prognoza",
  "landing.pricingFeatureForecasts": "Modeli prognoze",
  "landing.pricingFeatureForecastsFreeTier": "1 model",
  "landing.pricingFeatureForecastsPremiumTier": "{count, plural, one {#+ model} few {#+ modela} other {#+ modela}}",
  "landing.pricingFeatureReports": "Analize i izvještaji",
  "landing.pricingFeatureStationComparison": "Usporedba postaja",
  "landing.pricingFeatureWidgets": "Widgeti početnog zaslona",
  "landing.pricingFeatureYearOverYear": "Analiza godina za godinom",
  "landing.pricingFreeCta": "Započnite",
  "landing.pricingFreePrice": "0 €",
  "landing.pricingMostPopular": "Najpopularnije",
  "landing.pricingPremiumCta": "Započnite",
  "landing.pricingPremiumDescription": "Od 1,99 €/mjesec — pretplatite se na webu, App Storeu ili Google Playu",
  "landing.pricingSubtitle": "Započnite besplatno, nadogradite kada trebate više.",
  "landing.pricingTitle": "Jednostavne, transparentne cijene",
  "landing.statBrands": "Podržanih marki",
  "landing.statForecasts": "Modela prognoze",
  "landing.statStations": "Meteoroloških postaja",
  "landing.supportedDevicesNote": "Plus više od {count, number} javnih postaja iz mreže Svjetske meteorološke organizacije",
  "landing.supportedDevicesSubtitle": "Povežite svoju postojeću meteorološku postaju u nekoliko minuta. Podržavamo {count, plural, one {# veliku marku} few {# velike marke} other {# velikih marki}}, a dolaze i nove.",
  "landing.supportedDevicesTitle": "Radi s vašom postajom",
  "metrics.absolutePressure": "Apsolutni tlak",
  "metrics.airDensity": "Gustoća zraka",
  "metrics.airGap": "Zračni razmak",
  "metrics.apparentTemperature": "Prividna temperatura",
  "metrics.AQI": "AQI",
  "metrics.AQI_24H": "24h AQI",
  "metrics.avg": "Prosjek",
  "metrics.avg_wind": "Prosječan vjetar",
  "metrics.beaufort": "Beaufort",
  "metrics.blackGlobeTemperature": "Temp. crnog globusa",
  "metrics.boilerOn": "Bojler UKLJUČEN",
  "metrics.boilerOnInHours": "Bojler UKLJUČEN (sati)",
  "metrics.cloudCover": "Naoblaka",
  "metrics.co2": "CO2",
  "metrics.conductivity": "Vodljivost",
  "metrics.dailyPrecipitation": "Dnevne oborine",
  "metrics.dailyRain": "Dnevna kiša",
  "metrics.degreeDayShort": "DS",
  "metrics.depth": "Dubina",
  "metrics.depthSensors": "Senzori dubine",
  "metrics.dewPoint": "Točka rošenja",
  "metrics.distance": "Udaljenost",
  "metrics.downTrend": "Silazni trend",
  "metrics.ET": "Evapotranspiracija",
  "metrics.etToday": "ET danas",
  "metrics.feelsLike": "Subjektivni osjećaj",
  "metrics.feelsLikeWithFormula": "Subjektivni osjećaj ({formula})",
  "metrics.frostPoint": "Točka inja",
  "metrics.gust": "Udar vjetra",
  "metrics.gustDirection": "Smjer udara vjetra",
  "metrics.hail": "Tuča",
  "metrics.heatIndex": "Indeks toplote",
  "metrics.heatingDegreeDays": "Dnevni stupnjevi grijanja",
  "metrics.heatingPower": "Snaga grijanja",
  "metrics.humidex": "Humidex",
  "metrics.humidity": "Vlažnost",
  "metrics.lastLightningImpact": "Posljednji udar groma",
  "metrics.lastMeasure": "Posljednje mjerenje",
  "metrics.leafSensors": "Senzori lišća",
  "metrics.leafWetness": "Vlažnost lišća",
  "metrics.lightningDistance": "Udaljenost",
  "metrics.lightningStrikeCount": "Broj udara munje",
  "metrics.lightningStrikeDistance": "Udaljenost udara groma",
  "metrics.max": "Max.",
  "metrics.max_gust": "Maks. udar vjetra",
  "metrics.maxToday": "Maks. danas",
  "metrics.min": "Min.",
  "metrics.noise": "Buka",
  "metrics.normalizedHeatingCoefficient": "Normalizirani kvocijent zagrijavanja",
  "metrics.outdoorTemperature": "Vanjska temperatura",
  "metrics.PM_1": "PM 1",
  "metrics.PM_10": "PM 10",
  "metrics.PM_2P5": "PM 2.5",
  "metrics.precipitation": "Oborine",
  "metrics.pressure": "Tlak",
  "metrics.rain": "Kiša",
  "metrics.rainDurationValue": "Trajanje kiše: {duration}",
  "metrics.rainRate": "Intenzitet kiše",
  "metrics.relativePressure": "Relativni tlak",
  "metrics.setPoint": "Zadana temperatura",
  "metrics.snow": "Snijeg",
  "metrics.snowfall": "Snježne oborine",
  "metrics.soilMoisture": "Vlažnost tla",
  "metrics.soilSensors": "Senzori tla",
  "metrics.soilWaterTension": "Tenzija vode u tlu",
  "metrics.solarEnergy": "Solarna energija",
  "metrics.solarRadiation": "Solarno zračenje",
  "metrics.speed": "Brzina",
  "metrics.stableTrend": "Stabilan trend",
  "metrics.sum": "Suma",
  "metrics.temperature": "Temperatura",
  "metrics.temperatureSensors": "Senzori temperature/vlage",
  "metrics.temperatureShort": "Temp.",
  "metrics.thsw": "THSW",
  "metrics.thw": "THW",
  "metrics.upTrend": "Uzlazni trend",
  "metrics.uv": "UV",
  "metrics.visibility": "Vidljivost",
  "metrics.weatherCondition": "Vremenski uvjeti",
  "metrics.wetBulbGlobeTemperature": "Temp. vlažnog globusa",
  "metrics.wetBulbTemperature": "Temp. mokri termometar",
  "metrics.wind": "Vjetar",
  "metrics.windChill": "Hlađenje vjetra",
  "metrics.windDirection": "Smjer vjetra",
  "metrics.windRun": "Put vjetra",
  "metrics.windRunDescription": "Put vjetra je ukupna udaljenost koju vjetar prijeđe u određenom vremenskom razdoblju",
  "metrics.windSpeed": "Brzina vjetra",
  "navigation.allFavorites": "Prikaži sve",
  "navigation.breadcrumbs": "Navigacijski put",
  "navigation.collapseNavigation": "Sažmi navigaciju",
  "navigation.expandNavigation": "Proširi navigaciju",
  "navigation.main": "Glavna",
  "navigation.mapShort": "Karta",
  "navigation.skipToContent": "Preskoči na glavni sadržaj",
  "network.cancelError": "Zahtjev je otkazan",
  "network.connectionError": "Server je nedostupan",
  "network.networkError": "Mreža nije dostupna",
  "network.serverError": "Nešto nije u redu...",
  "network.timeoutError": "Povezivanje je isteklo",
  "network.tooManyRequests": "Previše zahtjeva. Pokušajte kasnije.",
  "network.unknownError": "Nepoznata greška",
  "premium.alreadyPremium": "Već imate Premium račun!",
  "premium.bestValue": "Najbolja ponuda",
  "premium.billingDetailsAndroid": "Besplatno probno razdoblje: ništa vam se neće naplatiti ako otkažete najmanje 24 sata prije kraja probnog razdoblja. Nakon toga se vaša pretplata na SmartMixin automatski obnavlja, osim ako je ne otkažete najmanje 24 sata prije kraja tekućeg razdoblja; otkazati je možete u bilo kojem trenutku u postavkama svog Google Play računa. Svaka se obnova naplaćuje po cijeni prikazanoj na gumbu iznad. Plaćanje se naplaćuje s vašeg Google Play računa pri potvrdi kupnje i na početku svakog razdoblja obnove.",
  "premium.billingDetailsIos": "Besplatno probno razdoblje: ništa vam se neće naplatiti ako otkažete najmanje 24 sata prije kraja probnog razdoblja. Nakon toga se vaša pretplata na SmartMixin automatski obnavlja, osim ako je ne otkažete najmanje 24 sata prije kraja tekućeg razdoblja; otkazati je možete u bilo kojem trenutku u postavkama svog App Store računa. Svaka se obnova naplaćuje po cijeni prikazanoj na gumbu iznad. Plaćanje se naplaćuje s vašeg App Store računa pri potvrdi kupnje i na početku svakog razdoblja obnove.",
  "premium.freeBannerBody": "Bez pretplate Premium svugdje dobivate GFS — vaši preferirani modeli i „svugdje drugdje” počinju raditi čim se pretplatite.",
  "premium.freeBannerTitle": "Preferencije vrijede uz Premium",
  "premium.freeSubscription": "Besplatna pretplata",
  "premium.freeTrialForPeriod": "Besplatno probno razdoblje od {period, plural, one {# dana} few {# dana} other {# dana}}",
  "premium.getUnlimitedAccess": "Neograničen pristup:",
  "premium.manageMySubscription": "Upravljaj pretplatom",
  "premium.notPurchasedYet": "Za ovaj račun trgovine nije pronađena nijedna kupnja SmartMixin Premium.",
  "premium.orChooseMonthly": "Ili odaberite mjesečno:",
  "premium.plansRetry": "Pokušaj ponovno",
  "premium.plansUnavailable": "Planove pretplate nije moguće učitati. Provjerite internetsku vezu i pokušajte ponovno.",
  "premium.premium": "SmartMixin Premium",
  "premium.premiumActive": "Aktivno",
  "premium.premiumAnnualTrialInfo": "Započnite s besplatnim probnim razdobljem od {days, plural, one {# dana} few {# dana} other {# dana}}",
  "premium.premiumCurrentPlan": "Trenutni plan",
  "premium.premiumDownloadApp": "Preuzmite aplikaciju za pretplatu:",
  "premium.premiumEndsOn": "Istječe {date}",
  "premium.premiumFeatureAlerts": "Vremenska upozorenja",
  "premium.premiumFeatureAnalysis": "Napredna analiza vremena",
  "premium.premiumFeatureCharts": "Usporedbe grafova",
  "premium.premiumFeatureExport": "Izvoz podataka",
  "premium.premiumFeatureForecast": "Regionalni prognostički modeli",
  "premium.premiumFeatureNotification": "Widget statusne trake",
  "premium.premiumFeatureTitle": "Premium značajka",
  "premium.premiumFeatureWidgets": "Widgeti početnog zaslona",
  "premium.premiumFreePlan": "Besplatno",
  "premium.premiumInactive": "Bez pretplate",
  "premium.premiumManageStoreSubscription": "Pretplatili ste se putem trgovine {store}. Ondje možete upravljati pretplatom ili je otkazati.",
  "premium.premiumManageWebSubscription": "Upravljajte pretplatom, ažurirajte način plaćanja ili otkažite.",
  "premium.premiumPremiumPlan": "Premium",
  "premium.premiumRenewsOn": "Obnavlja se {date}",
  "premium.premiumSubscribeAnnual": "Godišnje — 9,99 €/godina",
  "premium.premiumSubscribedOn": "Pretplaćeno putem {platform}",
  "premium.premiumSubscribedOnWeb": "Pretplaćeno putem weba",
  "premium.premiumSubscribeMonthly": "Mjesečno — 1,99 €/mjesec",
  "premium.premiumSubscribeOnWeb": "Pretplatite se sada kako biste otključali sve premium značajke.",
  "premium.premiumSubscriptionSuccess": "Vaša pretplata je aktivirana! Uživajte u svim premium značajkama.",
  "premium.premiumSubscriptionSuccessTitle": "Dobrodošli u Premium!",
  "premium.premiumWebappNotice": "Pretplata putem weba trenutačno nije dostupna.",
  "premium.pricePerMonth": "{price}/mjesec",
  "premium.pricePerYear": "{price}/godina",
  "premium.purchasedNetatmoPro": "Prethodno ste kupili Netatmo Pro ({date}). On vam daje pristup dijelu premium značajki. Pretplatite se na jednu od sljedećih ponuda ako želite pristup svim premium značajkama.",
  "premium.purchaseFailed": "Kupnju nije bilo moguće dovršiti. Pokušajte ponovno.",
  "premium.restoreFailed": "Vaše kupnje nije bilo moguće obnoviti. Pokušajte ponovno.",
  "premium.restorePurchase": "Obnovi kupnju",
  "premium.savingsPercent": "Uštedite {percent}%",
  "premium.seePremium": "Pogledaj Premium",
  "premium.startFreeTrial": "Započnite besplatno probno razdoblje",
  "premium.storeUnavailable": "Trgovina trenutačno nije dostupna. Pokušajte ponovno kasnije.",
  "premium.subscribeNow": "Pretplati se sada — bez probnog razdoblja",
  "premium.switchToPremium": "Pređi na SmartMixin Premium",
  "premium.thenPrice": "zatim {price}",
  "providerHints.ambientWeatherApiKey": "Stvoreno u postavkama računa na ambientweather.net.",
  "providerHints.davisApiSecret": "Prikazan samo jednom prilikom stvaranja V2 API ključa — čuvajte ga sigurno.",
  "providerHints.davisV2ApiKey": "Sa stranice V2 API ključeva na weatherlink.com.",
  "providerHints.ecowittApi": "Sa stranice API vašeg Ecowitt računa.",
  "providerHints.ecowittApp": "Ključ aplikacije, također iz vašeg Ecowitt računa.",
  "providerHints.myAcuriteCredentialsBanner": "Koristite e-poštu i lozinku vašeg My AcuRite računa — ne SmartMixin prijavu.",
  "providerHints.myAcuriteEmail": "E-pošta vašeg My AcuRite računa — ne vaša SmartMixin prijava.",
  "providerHints.myAcuritePassword": "Lozinka vašeg My AcuRite računa.",
  "providerHints.weatherflowToken": "Token za osobnu uporabu s tempestwx.com → postavke → autorizacije podataka.",
  "providerHints.wundergroundEditKey": "Koristi drugi ključ",
  "providerHints.wundergroundKey": "Dugi niz znakova sa stranice API ključeva vašeg Weather Underground računa — ne vaša lozinka za wunderground.com.",
  "providerHints.wundergroundKeyExample": "npr. 5f6a7b8c9dabcdef…",
  "providerHints.wundergroundKeyVerified": "API ključ provjeren",
  "providerHints.wundergroundNoStationsNearby": "Nije pronađena nijedna postaja u blizini. Pokušajte unijeti ID postaje izravno.",
  "providerHints.wundergroundStationIdExample": "npr. KCASANFR123",
  "providerIntro.ambientWeatherStep2": "Nabavite svoj Ambient Weather API ključ.",
  "providerIntro.davisStep2": "Nabavite svoj Davis V2 API ključ i API tajnu.",
  "providerIntro.ecowittStep2": "Nabavite svoj Ecowitt API ključ i ključ aplikacije.",
  "providerIntro.getStarted": "Započnite",
  "providerIntro.myAcuriteStep2": "Koristite e-poštu i lozinku svog postojećeg My AcuRite računa.",
  "providerIntro.netatmoEnergyStep2": "Prijavite se u Netatmo kada budete upitani — API ključ nije potreban.",
  "providerIntro.netatmoWeatherStep2": "Prijavite se u Netatmo kada budete upitani — API ključ nije potreban.",
  "providerIntro.signupBanner": "Skoro gotovo — stvorite svoj besplatni SmartMixin račun za povezivanje {provider}.",
  "providerIntro.step1": "Prijavite se u svoj SmartMixin račun (NE u {provider}).",
  "providerIntro.step3EmailPassword": "Unesite ih ovdje.",
  "providerIntro.step3KeyOrToken": "Zalijepite ovdje.",
  "providerIntro.step3OAuth": "Autorizirajte SmartMixin u skočnom prozoru.",
  "providerIntro.step3Wunderground": "Zalijepite svoj API ključ, a zatim odaberite obližnju postaju ili unesite bilo koji ID postaje.",
  "providerIntro.stepOfTotal": "Korak {step} od {total}",
  "providerIntro.title": "Poveži {provider}",
  "providerIntro.weatherflowStep2": "Nabavite svoj osobni Tempest token.",
  "providerIntro.wundergroundBrowsePublic": "Nemate postaju? Pregledajte javne",
  "providerIntro.wundergroundFindNearby": "Pronađi postaje u blizini",
  "providerIntro.wundergroundOrEnterId": "Ili unesite ID postaje",
  "providerIntro.wundergroundStep2": "Nabavite svoj Weather Underground API ključ. Zatim možete povezati bilo koju postaju — svoju ili javnu.",
  "reports.agroMeteorology": "Agrometeorologija",
  "reports.analysis": "Analiza",
  "reports.annualCumulativeRainfallComparison": "Usporedba ukupnih godišnjih oborina",
  "reports.annualHeatingDurationComparison": "Godišnja usporedba vremena grijanja",
  "reports.annualHeatingEfficiency": "Godišnja učinkovitost grijanja",
  "reports.annualIndoorComparison": "Godišnje usporedbe unutrašnjeg modula",
  "reports.annualOutdoorComparison": "Godišnja usporedba vanjskog modula",
  "reports.annualOutdoorReport": "Godišnji izvještaj o vanjskom modulu",
  "reports.annualReport": "Godišnji izvještaj",
  "reports.annualSolarReport": "Godišnje solarno izvješće",
  "reports.annualWaterBalance": "Godišnja vodna bilanca",
  "reports.annualWaterBalanceCarryOver": "Prenesi iz {year}. ({value})",
  "reports.annualWaterBalanceDescription": "Vodna bilanca (pojednostavljena verzija, koriste se samo kiša i evapotranspiracija) omogućuje upravljanje vodnim resursima",
  "reports.avgHumidity": "Prosječna vlažnost zraka",
  "reports.avgMaxTemperature": "Prosječna T°max",
  "reports.avgMetric": "Prosjek – {metric}",
  "reports.avgMinTemperature": "Prosječna T°min",
  "reports.avgPressure": "Prosječna vrijednost tlaka zraka",
  "reports.avgTemperature": "Prosječna temperatura",
  "reports.chartsAndTable": "Dijagrami i tablica",
  "reports.climateNormalPeriodOfRecord": "Razdoblje mjerenja ({years, plural, one {# godina} few {# godine} other {# godina}})",
  "reports.climateNormals": "Klimatske normale",
  "reports.climateNormalStandardLabel": "Standardna normala ({period})",
  "reports.climateTrendPerDecade": "Trend temperature: {value} po desetljeću tijekom {years, plural, one {# godine} few {# godine} other {# godina}}",
  "reports.coldestMonthRanking": "{month} – rekord hladnoće",
  "reports.comfortable": "Ugodna (45% {lessThan} vlažnost zraka ≤ 60%)",
  "reports.coverageAllDays": "{total, plural, one {# dan} few {Sva # dana} other {Svih # dana}}",
  "reports.coverageMetricsCount": "{metrics}: {count} od {total, plural, one {# dana} few {# dana} other {# dana}}",
  "reports.coverageMetricsEveryDay": "{metrics}: svaki dan",
  "reports.coverageMonthToDate": "Od početka mjeseca",
  "reports.coverageNoReadings": "Nema mjerenja: {dates}",
  "reports.coverageReadingsCount": "Mjerenja u {count} od {total, plural, one {# dana} few {# dana} other {# dana}}",
  "reports.coverageTodayUntil": "Danas do {time}",
  "reports.coverageYearToDate": "Od početka godine",
  "reports.cumulativeRainfall": "Kumulativne oborine",
  "reports.cumulativeRainfallDescription": "Pratite ukupne oborine koje se akumuliraju tijekom odabranog razdoblja.",
  "reports.dailyMaxRainfall": "Maksimalne dnevne oborine",
  "reports.dataExport": "Izvezi podatke",
  "reports.dataExportXlsxFormatDescription": "Izvezite sve vaše podatke u excel datoteku (*.xlsx). Nakon što kliknete na gumb, nakon par minuta će vam stići email sa obrađenim podacima.",
  "reports.daysOfData": "{days, plural, one {# dan} few {# dana} other {# dana}} podataka",
  "reports.daysWithFrost": "Dani sa mrazom",
  "reports.daysWithHeavyRain": "Dani s jakom kišom (≥ {threshold})",
  "reports.daysWithoutThaw": "Ledeni dani",
  "reports.daysWithStrongFrost": "Dani sa jakim mrazom",
  "reports.emailSent": "Email je poslat na vašu adresu",
  "reports.frostDays": "Mrazni dani",
  "reports.grasslandTemperatureSum": "Zbroj temperatura travnjaka",
  "reports.grasslandTemperatureSumDescription": "Održivi oporavak vegetacije kada zbroj dosegne {threshold}",
  "reports.grasslandThresholdLabel": "Početak vegetacije: {threshold}",
  "reports.growingDegreeDays": "Stupanj-dani rasta",
  "reports.highPressure": "Anticiklona (Prosječna vrijednost tlaka zraka ≥ {threshold})",
  "reports.historyImportInProgress": "Starija povijest vaše postaje još se uvozi. Sljedećih nekoliko dana pojavit će se još godina.",
  "reports.iceDays": "Ledeni dani",
  "reports.indoorReport": "Izvještaj unutrašnjeg modula",
  "reports.keyFacts": "Važne činjenice",
  "reports.longestDrySpell": "Najdulje sušno razdoblje",
  "reports.longestRunOfRainyDays": "Broj uzastopnih kišnih dana",
  "reports.longestRunWithoutRun": "Broj uzastopnih dana bez kiše",
  "reports.longestWetSpell": "Najdulje kišno razdoblje",
  "reports.lowPressure": "Nizak tlak (prosječna vrijednost tlaka zraka {lessThan} {threshold})",
  "reports.maxHumidity": "Maksimalna vlažnost",
  "reports.maxMetric": "Maksimum – {metric}",
  "reports.maxPressure": "Najviši tlak",
  "reports.maxTemperature": "Najviša temperatura",
  "reports.maxTempGreaterThan": "T°max ≥",
  "reports.maxTempMagnitude24h": "Maksimalna dnevna amplituda (/24H)",
  "reports.minHumidity": "Minimalna vlažnost",
  "reports.minMetric": "Minimum – {metric}",
  "reports.minPressure": "Najniži tlak",
  "reports.minTemperature": "Najniža temperatura",
  "reports.minTempMagnitude24h": "Minimalna dnevna amplituda (/24H)",
  "reports.monthlyAverageCountdown": "{days, plural, one {Još # dan} few {Još # dana} other {Još # dana}} ovaj mjesec",
  "reports.monthlyAverageCountdownDetail": "Tada se pojavljuju prosjek ovog mjeseca i njegov poredak.",
  "reports.monthlyAverageRule": "Mjesečni prosjeci i poreci pojavljuju se kada kalendarski mjesec ima zabilježeno {days, plural, one {# dan} few {# dana} other {# dana}}.",
  "reports.monthlyHeatingEfficiency": "Mjesečna učinkovitost grijanja",
  "reports.monthlyOutdoorReport": "Mjesečni izvještaj vanjskog modula",
  "reports.monthlyReport": "Mjesečni izvještaj",
  "reports.monthlySolarReport": "Mjesečni solarni izvještaj",
  "reports.monthlyWindReport": "Mjesečni izvještaj o vjetru",
  "reports.monthsOfData": "{months, plural, one {# mjesec} few {# mjeseca} other {# mjeseci}} podataka",
  "reports.noReadings": "Nema mjerenja",
  "reports.numberOfDays": "Broj dana",
  "reports.onThisDayChartRule": "Grafikon po godinama pojavit će se kada za {date} bude zabilježeno {count, plural, one {# godina} few {# godine} other {# godina}}.",
  "reports.onThisDayChartSummary": "{years, plural, one {# godina} few {# godine} other {# godina}} s temperaturom, od {first} do {last}. Rekordna vrućina {high} ({highYears}), rekordna hladnoća {low} ({lowYear}). Normalan dan od {min} do {max}.",
  "reports.onThisDayChartSummaryNoNormal": "{years, plural, one {# godina} few {# godine} other {# godina}} s temperaturom, od {first} do {last}. Rekordna vrućina {high} ({highYears}), rekordna hladnoća {low} ({lowYear}).",
  "reports.onThisDayCoverage": "{years, plural, one {# godina od {firstYear}} few {# godine od {firstYear}} other {# godina od {firstYear}}}",
  "reports.onThisDayDataSince": "Ova postaja ima podatke od {date}.",
  "reports.onThisDayEveryYear": "Svaki {date} u arhivi",
  "reports.onThisDayGapNoData": "nema podataka",
  "reports.onThisDayHighOnlySummary": "{year}: maksimum {max}, kiša {rain}",
  "reports.onThisDayInHistory": "Na današnji dan u povijesti",
  "reports.onThisDayLeaveOk": "Možete napustiti ovaj zaslon; učitavanje se nastavlja.",
  "reports.onThisDayLoadFailed": "Nije moguće učitati {date}. Provjerite vezu i pokušajte ponovno.",
  "reports.onThisDayLowOnlySummary": "{year}: minimum {min}, kiša {rain}",
  "reports.onThisDayNoDataRun": "{start}–{end} · nema podataka ({count, plural, one {# godina} few {# godine} other {# godina}})",
  "reports.onThisDayNormal": "Normalan dan: od {min} do {max}",
  "reports.onThisDayNoYears": "Još nema potpunog dana {date}",
  "reports.onThisDayNoYearsDetail": "Ova stranica popunit će se od prvog dana {date} koji postaja u potpunosti zabilježi.",
  "reports.onThisDayNoYearSelected": "Nije odabrana godina",
  "reports.onThisDayOneReading": "1 mjerenje",
  "reports.onThisDayOneReadingSummary": "{year}: {value}, 1 mjerenje, kiša {rain}",
  "reports.onThisDayOpenRecords": "Otvori Rekordi i klima",
  "reports.onThisDayPickHint": "Mijenja prikazani dan",
  "reports.onThisDayPickTitle": "Odaberite dan",
  "reports.onThisDayRain": "Kiša {date}",
  "reports.onThisDayRainNotMeasured": "nije mjerena",
  "reports.onThisDayRainOnlySummary": "{year}: kiša {rain}",
  "reports.onThisDayRainSince": "kiša od {year}",
  "reports.onThisDayRainSummary": "Kiša {date}. Najkišovitiji dan {value} ({years}).",
  "reports.onThisDayRetry": "Pokušaj ponovno",
  "reports.onThisDaySingleReading": "Godine s jednim mjerenjem tog dana ({count}) nisu prikazane na grafikonu.",
  "reports.onThisDaySlowLoad": "Čitanje {years, plural, one {# godine} few {# godine} other {# godina}} za {date}. Prvo otvaranje datuma može potrajati do 20 sekundi.",
  "reports.onThisDaySlowLoadGeneric": "Čitanje povijesti ove postaje za {date}. Prvo otvaranje datuma može potrajati do 20 sekundi.",
  "reports.onThisDayTied": "izjednačeno s {years}",
  "reports.onThisDayTiedMore": "izjednačeno s {years} +{count}",
  "reports.onThisDayYearSummary": "{year}: minimum {min}, maksimum {max}, kiša {rain}",
  "reports.onThisDayYearTied": "{year} ({tied})",
  "reports.outdoorReport": "Izvještaj vanjskog modula",
  "reports.overviewSection": "Pregled",
  "reports.rainfall": "Oborine",
  "reports.rainyDays": "Dani sa oborinama",
  "reports.recordCalendarDay": "Kalendarski dan (od ponoći do ponoći)",
  "reports.recordClimatologicalDay": "Klimatološki dan (06–06 UTC)",
  "reports.recordClimDayBody": "Najkišovitiji dan računa se na dva načina. Kalendarski dan traje od ponoći do ponoći po vremenu postaje. Klimatološki dan traje od 06:00 do 06:00 UTC, kako ga računaju meteorološke službe. Dva načina mogu istu oluju podijeliti različito, zato se njihovi zbrojevi mogu razlikovati, a ponekad i njihovi datumi.",
  "reports.recordDailyRain": "Najkišovitiji dan",
  "reports.recordFromHourlyReadings": "Iz satnih mjerenja",
  "reports.recordHigh": "Rekordna vrućina",
  "reports.recordLow": "Rekordna hladnoća",
  "reports.recordOfficialBody": "Meteorološka služba objavljuje dnevni maksimum i minimum za ovu postaju, očitane s maksimalnog i minimalnog termometra. Oni bilježe kratke vrhunce koje satna mjerenja propuste, pa zamjenjuju vrijednosti izračunate iz satnih mjerenja.",
  "reports.recordOfficialValue": "Službena vrijednost",
  "reports.recordsAndClimatology": "Rekordi i klima",
  "reports.recordSheetTitle": "O ovim rekordima",
  "reports.recordsSince": "Rekordi od {date}",
  "reports.recordWindGust": "Najjači udar vjetra",
  "reports.relativelyWet": "Relativno vlažno (60% {lessThan} Vlažnost ≤ 80%)",
  "reports.sectionReportCount": "{count, plural, one {# izvješće} few {# izvješća} other {# izvješća}}",
  "reports.sendEmail": "Pošalji email",
  "reports.summerDays": "Ljetni dani",
  "reports.tableScrollRegion": "{title}, pomiče se vodoravno",
  "reports.tooDry": "Presuho (Vlažnost ≤ 45%)",
  "reports.tooWet": "Prevlažno (Vlažnost {greaterThan} 80%)",
  "reports.tropicalNights": "Tropske noći",
  "reports.unlockPremiumSubtitle": "Uključeno u SmartMixin Premium",
  "reports.unlockPremiumTitle": "Otključajte {count, plural, one {# premium značajku} few {# premium značajke} other {# premium značajki}}",
  "reports.warmestMonthRanking": "{month} – rekord vrućine",
  "reports.waterBalance": "Vodna bilanca",
  "reports.yearsOfData": "{years, plural, one {# godina} few {# godine} other {# godina}} podataka",
  "reports.yearToDateTemperatureComparison": "Usporedba temperature od početka godine",
  "sensors.bgtSensors": "Crni globus & WBGT",
  "sensors.cameraFeed": "Kamera",
  "sensors.compareHumidity": "Usporedi vlažnost",
  "sensors.compareMoisture": "Usporedi vlagu tla",
  "sensors.comparePm25": "Usporedi PM2.5",
  "sensors.compareTemperatures": "Usporedi temperature",
  "sensors.compareWaterTension": "Usporedi tenziju vode u tlu",
  "sensors.depthByChannel": "Dubina po kanalu",
  "sensors.heatStressExtreme": "Ekstreman toplinski stres",
  "sensors.heatStressModerate": "Umjeren toplinski stres",
  "sensors.heatStressNone": "Nema toplinskog stresa",
  "sensors.heatStressStrong": "Jak toplinski stres",
  "sensors.heatStressVeryStrong": "Vrlo jak toplinski stres",
  "sensors.indoorClimate": "Unutarnja klima",
  "sensors.indoorCo2Levels": "Razine CO2",
  "sensors.indoorTemperatureAndHumidity": "Temperatura i vlažnost",
  "sensors.leafWetnessByChannel": "Vlažnost listova po kanalu",
  "sensors.lightningSensor": "Munja",
  "sensors.moistureByChannel": "Vlaga tla po kanalu",
  "sensors.noDataAvailable": "Nema dostupnih podataka",
  "sensors.pm10AndAqi": "PM10 & AQI",
  "sensors.pm1AndAqi": "PM1.0 & AQI",
  "sensors.pm25AndAqi": "PM2.5 & AQI",
  "sensors.pm25ByChannel": "PM2.5 po kanalu",
  "sensors.pm4AndAqi": "PM4.0 & AQI",
  "sensors.selectChannel": "Odaberite kanal",
  "sensors.sensorDetailDescription": "Pregledajte povijesne podatke i trendove za kanale senzora.",
  "sensors.sensorHistory": "Povijest senzora",
  "sensors.soilConductivityByChannel": "Vodljivost po kanalu",
  "sensors.soilTemperatureByChannel": "Temperatura tla po kanalu",
  "sensors.strikesToday": "Udari danas",
  "sensors.temperatureByChannel": "Temperatura po kanalu",
  "sensors.viewChart": "Prikaži grafikon",
  "sensors.waterTensionByChannel": "Tenzija vode u tlu po kanalu",
  "settings.appearance": "Izgled",
  "settings.appVersion": "SmartMixin v{version}",
  "settings.arabic": "arapski",
  "settings.bulgarian": "bugarski",
  "settings.catalan": "katalonski",
  "settings.chartGestures": "Geste na dijagramu",
  "settings.chartGesturesDescription": "Prelaskom preko dijagrama mijenjate period, skupljanjem prstima mijenjate vremensku skalu",
  "settings.choiceCount": "{count, plural, one {Dostupno: #} few {Dostupno: #} other {Dostupno: #}}",
  "settings.contactUs": "Kontaktirajte nas",
  "settings.contactUsDescription": "Zatražite pomoć ili pošaljite povratnu informaciju",
  "settings.croatian": "hrvatski",
  "settings.czech": "češki",
  "settings.dailyDetailByPeriods": "Dnevni detalji po razdobljima",
  "settings.dailyDetailByPeriodsDescription": "Grupiraj 24 sata u noć, jutro, poslijepodne i večer — ista podjela koju koristi dnevni sažetak.",
  "settings.danish": "danski",
  "settings.dark": "Tamna tema",
  "settings.dataDisplay": "Prikaz podataka",
  "settings.dateAndTime": "Datum i vrijeme",
  "settings.donateButton": "Donirajte",
  "settings.donateDescription": "SmartMixin razvija mali tim. Ako vam je koristan, možete podržati njegov razvoj jednokratnom donacijom u bilo kojem iznosu. To je dar — ne mijenja vaš plan niti otključava ikakve značajke.",
  "settings.donateSuccessBody": "Vaša donacija pomaže da SmartMixin nastavi raditi i da se poboljšava. Iskreno to cijenimo.",
  "settings.donateSuccessTitle": "Hvala vam na podršci!",
  "settings.donateTitle": "Podržite SmartMixin",
  "settings.dragToReorder": "Povucite za promjenu redoslijeda",
  "settings.dutch": "nizozemski",
  "settings.english": "engleski",
  "settings.french": "francuski",
  "settings.german": "njemački",
  "settings.gestures": "Geste",
  "settings.greek": "grčki",
  "settings.hungarian": "mađarski",
  "settings.italian": "talijanski",
  "settings.japanese": "japanski",
  "settings.korean": "korejski",
  "settings.language": "Jezik",
  "settings.languageDescription": "Jezik po izboru",
  "settings.light": "Svijetla tema",
  "settings.mapTheme": "Tema karte",
  "settings.mapThemeAuto": "Auto",
  "settings.mapThemeDark": "Tamna",
  "settings.mapThemeDescription": "Uz Auto karta prati temu aplikacije.",
  "settings.mapThemeLight": "Svijetla",
  "settings.measurementUnits": "Mjerne jedinice",
  "settings.netatmoDashboard": "Netatmo nadzorna ploča",
  "settings.netatmoLayoutCards": "Popis kartica",
  "settings.netatmoLayoutCardsDescription": "Jedna kartica po modulu, sve u jednom pomicanju",
  "settings.netatmoLayoutClassic": "Klasični",
  "settings.netatmoLayoutClassicDescription": "Dvije kartice, klizanje između modula",
  "settings.netatmoNewLayoutNotice": "Novi raspored: jedna kartica po modulu.",
  "settings.netatmoSwitchBackToClassic": "Natrag na klasični",
  "settings.netatmoSwitchToLayout": "Prebaci na {layout}",
  "settings.norwegian": "norveški",
  "settings.notificationsSection": "Obavijesti",
  "settings.ongoingNotificationEnabled": "Omogući trajnu obavijest",
  "settings.ongoingNotificationMetrics": "Prikazane metrike",
  "settings.ongoingNotificationPermissionRequired": "Potrebna je dozvola za obavijesti",
  "settings.ongoingNotificationPreviewHint": "Pregled — uključite widget da bi se prikazao",
  "settings.ongoingNotificationStatusBar": "Statusna traka",
  "settings.polish": "poljski",
  "settings.portuguese": "portugalski",
  "settings.preferencesSection": "Preferencije",
  "settings.privacyPolicy": "Politika privatnosti",
  "settings.russian": "ruski",
  "settings.serbian": "srpski",
  "settings.settings": "Postavke",
  "settings.settingsPageTitle": "Postavke - {page}",
  "settings.slovak": "slovački",
  "settings.smallDecimals": "Male decimale",
  "settings.smallDecimalsDescription": "Prikaži decimalne znamenke u manjoj veličini",
  "settings.spanish": "španjolski",
  "settings.statusBarWidget": "Widget statusne trake",
  "settings.statusBarWidgetDescription": "Uvijek vidljivi vremenski podaci",
  "settings.subscriptionSection": "Pretplata",
  "settings.supportSection": "Podrška",
  "settings.swedish": "švedski",
  "settings.systemTheme": "Sistemska tema",
  "settings.termsOfService": "Uvjeti korištenja",
  "settings.themeDarkShort": "Tamna",
  "settings.themeLightShort": "Svijetla",
  "settings.themeSystemShort": "Sustav",
  "settings.turkish": "turski",
  "settings.ukrainian": "ukrajinski",
  "settings.units": "Jedinice",
  "settings.unitsDescription": "Mjerne jedinice unutar aplikacije",
  "settings.update": "Ažuriraj",
  "settings.windDirectionConvention": "Strelica smjera vjetra",
  "settings.windDirectionConventionDescription": "Odaberite prikaz strelica smjera vjetra",
  "settings.windDirectionMeteorological": "Smjer podrijetla",
  "settings.windDirectionMeteorologicalDescription": "Strelica pokazuje odakle vjetar puše (meteorološka konvencija)",
  "settings.windDirectionOceanographic": "Smjer strujanja",
  "settings.windDirectionOceanographicDescription": "Strelica pokazuje kuda vjetar puše (oceanografska konvencija)",
  "stations.addAStation": "Dodaj postaju",
  "stations.addToFavorites": "Dodaj u favorite",
  "stations.addYourOwnStation": "Dodajte vlastitu postaju",
  "stations.allowPreciseLocation": "Dopusti preciznu lokaciju",
  "stations.approximateLocationUnavailable": "Približna lokacija nije dostupna. Dodirnite za dopuštanje precizne lokacije.",
  "stations.backToCurrentLocation": "Natrag na trenutno mjesto",
  "stations.backToPlace": "Natrag: {place}",
  "stations.browserLocationUnavailable": "Vašu lokaciju nije moguće pronaći. Provjerite dopušta li vaš preglednik ovoj stranici da je koristi, a zatim pokušajte ponovno.",
  "stations.calculatedFor": "Izračunato za {time} · {model}",
  "stations.clearRecentLocations": "Očisti sve",
  "stations.currentLocation": "Trenutno mjesto",
  "stations.customizedStationName": "Prilagođeni naziv postaje",
  "stations.editMyWeather": "Uredi Moje vrijeme",
  "stations.favoriteLocations": "Favoriti",
  "stations.filterStations": "Filtriraj postaje",
  "stations.filterStationSourceDescription": "Odaberite pružatelje postaja koje želite prikazati na karti",
  "stations.findingYourLocation": "Određivanje vaše lokacije…",
  "stations.hiddenFromMyWeather": "Skriveno: {name}",
  "stations.hiddenStations": "Skrivene postaje",
  "stations.hiddenStationsDescription": "Postaju možete ponovno prikazati dodirom na ikonu oka pokraj nje.",
  "stations.hideStationNamed": "Sakrij {station}",
  "stations.lastSeen": "posljednji put {time}",
  "stations.loadingStation": "Učitavanje postaje…",
  "stations.location": "Lokacija",
  "stations.locationAddedToFavorites": "Lokacija dodana favoritima",
  "stations.locationNotGranted": "Dozvola za lokaciju nije odobrena. Dopustite pristup svojoj lokaciji u postavkama uređaja.",
  "stations.locationRemovedFromFavorites": "Lokacija uklonjena iz favorita",
  "stations.locations": "Lokacije",
  "stations.locationUnavailable": "Nije moguće dohvatiti vašu lokaciju. Provjerite postavke uređaja.",
  "stations.maxFavoriteLocationsReached": "Možete imati najviše 5 omiljenih lokacija. Uklonite jednu da biste dodali drugu.",
  "stations.modifyFavoriteStations": "Izmijenite omiljene postaje",
  "stations.modifyFavoriteStationsDescription": "Svoje omiljene postaje možete preurediti povlačenjem. Također ih možete ukloniti s popisa.",
  "stations.moreStationsFailed": "Učitavanje dodatnih postaja nije uspjelo",
  "stations.myLocation": "Moja lokacija",
  "stations.myStations": "Moje postaje",
  "stations.myWeather": "Moje vrijeme",
  "stations.myWeatherIntroBody": "Vaše postaje ostaju na vrhu. Pretraživanje sada pronalazi mjesta i postaje.",
  "stations.myWeatherIntroOk": "U redu",
  "stations.myWeatherIntroTitle": "Postaje i mjesta na jednom popisu",
  "stations.myWeatherItemActions": "Radnje za {name}",
  "stations.nearbyWeatherStations": "Obližnje meteorološke postaje",
  "stations.noLocationsFound": "Nije pronađena nijedna lokacija",
  "stations.noLocationTitle": "Za koje mjesto želite vremensku prognozu?",
  "stations.noLongerReported": "Više nije na popisu",
  "stations.noLongerReportedBy": "{provider}: nije na popisu od {date}",
  "stations.noPlaceFound": "Nije pronađeno nijedno mjesto",
  "stations.noSearchResults": "Nijedan članak ne odgovara vašem pretraživanju",
  "stations.noStationNamed": "Nema postaje naziva „{query}”",
  "stations.noStationsFound": "Nisu pronađene postaje",
  "stations.noWeatherStationYet": "Još uvijek nemate meteorološku postaju",
  "stations.places": "Mjesta",
  "stations.placeSearchFailed": "Učitavanje mjesta nije uspjelo",
  "stations.recentLocations": "Nedavni",
  "stations.removedFromMyWeather": "Uklonjeno: {name}",
  "stations.removeFromFavorites": "Ukloni iz omiljenih",
  "stations.removeFromMyWeatherFailed": "Uklanjanje nije uspjelo: {name}",
  "stations.removeStationNamed": "Ukloni {station} iz omiljenih",
  "stations.reorderStationNamed": "Premjesti {station}",
  "stations.searchForLocation": "Potraži lokaciju",
  "stations.searchForWeatherStation": "Potraži postaju",
  "stations.searchPlaceOrStation": "Potraži mjesto ili postaju",
  "stations.searchResultsFound": "{count, plural, one {Pronađen # rezultat} few {Pronađena # rezultata} other {Pronađeno # rezultata}}",
  "stations.searchSummary": "{places, plural, one {# mjesto} few {# mjesta} other {# mjesta}}, {stations, plural, one {# postaja} few {# postaje} other {# postaja}}",
  "stations.searchTryAgain": "Pokušaj ponovno",
  "stations.selectStationForComparison": "Odaberite postaju za usporedbu",
  "stations.showAllStations": "Prikaži sve ({count})",
  "stations.shownInMyWeather": "Ponovno prikazano: {name}",
  "stations.stationAddedToFavorites": "Postaja je dodana u omiljene",
  "stations.stationInformation": "Informacije o postaji",
  "stations.stationName": "Naziv postaje",
  "stations.stationObservationsDescription": "Prikaži najnovija opažanja meteoroloških postaja",
  "stations.stationRemovedFromFavorites": "Postaja je uklonjena iz omiljenih",
  "stations.stationSearchFailed": "Učitavanje postaja nije uspjelo",
  "stations.stationsLoading": "Učitavanje meteoroloških postaja",
  "stations.stationType": "Tip postaje",
  "stations.statusOffline": "Izvan mreže",
  "stations.statusOnline": "Na mreži",
  "stations.statusStale": "Zastarjelo",
  "stations.undoRemove": "Poništi",
  "stations.unhideStationNamed": "Ponovno prikaži {station}",
  "stations.useMyLocation": "Koristi moju lokaciju",
  "stations.weatherStation": "Meteorološka postaja",
  "stations.weatherStations": "Meteorološke postaje",
  "stations.welcomeConnectService": "Posjedujete meteorološku postaju? Povežite svoj servis",
  "stations.welcomeSubtitle": "Vaše vrijeme, sve na jednom mjestu",
  "thermostat.away": "Odsutnost",
  "thermostat.boilerOn": "Bojler UKLJUČEN",
  "thermostat.hg": "Zaštita od mraza",
  "thermostat.homeInformation": "Informacije o kući",
  "thermostat.homeName": "Ime kuće",
  "thermostat.manualBoost": "Ručno povećanje",
  "thermostat.manualSetpointUntil": "Ručna zadana vrijednost do",
  "thermostat.noThermostatYet": "Nemate termostat.",
  "thermostat.relay": "Relej",
  "thermostat.room": "Prostorija",
  "thermostat.roomAnticipating": "Grijanje unaprijed za sljedeću zakazanu temperaturu",
  "thermostat.roomOpenWindow": "Otkriven otvoren prozor, grijanje pauzirano",
  "thermostat.rooms": "Prostorije",
  "thermostat.smartThermostat": "Pametni termostat",
  "thermostat.smartValve": "Pametni ventil",
  "thermostat.whenBackHome": "Kad se vraćate doma?",
  "units.celsius": "Celzij",
  "units.fahrenheit": "Fahrenheit",
  "units.inch": "Inči",
  "units.inchOfMercury": "Inči živinog stupa",
  "units.kelvin": "Kelvin",
  "units.kilometerPerHour": "Kilometri na sat",
  "units.knot": "Čvorovi",
  "units.meterPerSecond": "Metri u sekundi",
  "units.milePerHour": "Milje na sat",
  "units.millibar": "Milibari",
  "units.millimeter": "Milimetri",
  "units.millimeterOfMercury": "Milimetri živinog stupa",
  "weatherConditions.blizzard": "Mećava",
  "weatherConditions.blowingDust": "Uzvitlana prašina",
  "weatherConditions.blowingSnow": "Vijavica",
  "weatherConditions.breezy": "Lagan vjetar",
  "weatherConditions.clear": "Vedro",
  "weatherConditions.cloudy": "Oblačno",
  "weatherConditions.drizzle": "Rosulja",
  "weatherConditions.flurries": "Slab snijeg",
  "weatherConditions.foggy": "Magla",
  "weatherConditions.freezingDrizzle": "Ledena rosulja",
  "weatherConditions.freezingRain": "Ledena kiša",
  "weatherConditions.frigid": "Ledena hladnoća",
  "weatherConditions.hail": "Tuča",
  "weatherConditions.haze": "Suha mutnoća",
  "weatherConditions.heavyRain": "Jaka kiša",
  "weatherConditions.heavySnow": "Jak snijeg",
  "weatherConditions.hot": "Vrućina",
  "weatherConditions.hurricane": "Uragan",
  "weatherConditions.isolatedThunderstorms": "Izolirana grmljavinska nevremena",
  "weatherConditions.mixedRainAndHail": "Kiša i tuča",
  "weatherConditions.mostlyClear": "Pretežno vedro",
  "weatherConditions.mostlyCloudy": "Pretežno oblačno",
  "weatherConditions.mostlySunny": "Pretežno sunčano",
  "weatherConditions.notAvailable": "Vremenski uvjeti nisu dostupni",
  "weatherConditions.partlyCloudy": "Djelomično oblačno",
  "weatherConditions.rain": "Kiša",
  "weatherConditions.rainSleet": "Kiša i ledene kuglice",
  "weatherConditions.rainSnow": "Kiša i snijeg",
  "weatherConditions.scatteredShowers": "Mjestimični pljuskovi",
  "weatherConditions.scatteredSnowShowers": "Mjestimični snježni pljuskovi",
  "weatherConditions.scatteredThunderstorms": "Mjestimična grmljavinska nevremena",
  "weatherConditions.showers": "Pljuskovi",
  "weatherConditions.sleet": "Ledene kuglice",
  "weatherConditions.smoke": "Dim",
  "weatherConditions.snow": "Snijeg",
  "weatherConditions.snowShowers": "Snježni pljuskovi",
  "weatherConditions.strongStorms": "Jaka grmljavinska nevremena",
  "weatherConditions.sunny": "Sunčano",
  "weatherConditions.thunderstorms": "Grmljavinska nevremena",
  "weatherConditions.tornado": "Tornado",
  "weatherConditions.tropicalStorm": "Tropska oluja",
  "weatherConditions.windy": "Vjetrovito",
  "weatherConditions.wintryMix": "Mješovite zimske oborine",
  "weatherMap.clusterMarkerName": "{metric} {value}, medijan od {count, plural, one {# postaje} few {# postaje} other {# postaja}}, povećaj",
  "weatherMap.legendHeavy": "Jak",
  "weatherMap.legendLight": "Slab",
  "weatherMap.legendLightningHelp": "Boja prikazuje starost svake munje u posljednjih {minutes} minuta — najnovije bijelom, najstarije tamnocrvenom.",
  "weatherMap.legendNewest": "Najnovije",
  "weatherMap.legendOldest": "Najstarije",
  "weatherMap.legendStationsHelp": "Boja oznake odražava vrijednost odabrane veličine.",
  "weatherMap.lightningDataAttribution": "Podaci o munjama: Blitzortung.org",
  "weatherMap.lightningStrikes": "Udari munja",
  "weatherMap.lightningStrikesDescription": "Prikaži udare munja u stvarnom vremenu na karti",
  "weatherMap.mapLayers": "Slojevi karte",
  "weatherMap.mapLegend": "Legenda karte",
  "weatherMap.mapMode": "Način prikaza karte",
  "weatherMap.mapNameForecast": "Prognostička karta, {model}, {variable}",
  "weatherMap.mapNameObservations": "Meteokarta, opažanja",
  "weatherMap.modeForecast": "Prognoza",
  "weatherMap.modeObservations": "Opažanja",
  "weatherMap.radarCardLabel": "Radar oborina u {time}",
  "weatherMap.radarDataAttribution": "Podaci radara: NOAA / EUMETNET OPERA / Radar-DPC via LibreWXR",
  "weatherMap.radarLoading": "Učitavanje radara oborina",
  "weatherMap.radarTime": "Vrijeme radarske snimke",
  "weatherMap.radarUnavailable": "Radar nije dostupan",
  "weatherMap.rainRadar": "Radar oborina",
  "weatherMap.rainRadarDescription": "Prikaz kišnog radara na karti",
  "weatherMap.resetBearing": "Povucite za okretanje karte, kliknite za vraćanje prema sjeveru",
  "weatherMap.showingForecast": "Prikazana prognoza: {model}, {variable}",
  "weatherMap.stationMarkerName": "{metric} {value}, jedna postaja",
  "weatherMap.stationMarkersHint": "Strelicama se krećete između postaja",
  "weatherMap.stationMarkerWindValue": "{speed}, smjer {direction}",
  "weatherMap.weatherflowNCRain": "NC rain (Nearcast Rain)",
  "weatherMap.weatherflowNCRainDescription": "NC Rain dodatni je izvor podataka putem Tempest Weather Systema, kojeg pokreće Nearcast Technology. Podaci NC Rain procjena su prosječne akumulacije oborina oko vašeg Tempesta na razini susjedstva",
  "weatherMap.weatherMap": "Meteokarta",
  "weatherMap.weatherMapMetaDescription": "SmartMixin nudi interaktivne karte vremena i radara za vremenske uvjete diljem svijeta.",
  "weatherMap.zoomIn": "Povećaj",
  "weatherMap.zoomOut": "Smanji",
  "weatherWarnings.activeNow": "Trenutačno aktivna",
  "weatherWarnings.agencyMessage": "Poruka meteorološke službe",
  "weatherWarnings.areaCovered": "Obuhvaćeno područje",
  "weatherWarnings.areaThisLocation": "{area} (ova lokacija)",
  "weatherWarnings.areaYourStation": "{area} (vaša meteorološka postaja)",
  "weatherWarnings.badgeLabel": "{others, plural, =0 {Službeno upozorenje, {severity}: {hazard}} one {Službeno upozorenje, {severity}: {hazard}, i još #} few {Službeno upozorenje, {severity}: {hazard}, i još #} other {Službeno upozorenje, {severity}: {hazard}, i još #}}",
  "weatherWarnings.badgeLabelUpcoming": "{others, plural, =0 {Nadolazeće službeno upozorenje, {severity}: {hazard}} one {Nadolazeće službeno upozorenje, {severity}: {hazard}, i još #} few {Nadolazeće službeno upozorenje, {severity}: {hazard}, i još #} other {Nadolazeće službeno upozorenje, {severity}: {hazard}, i još #}}",
  "weatherWarnings.crumb": "Službena upozorenja",
  "weatherWarnings.emptyBody": "Nacionalna meteorološka služba nema važećih upozorenja za ovo mjesto. Ponovno provjeravamo svakih nekoliko minuta.",
  "weatherWarnings.emptyTitle": "Nema službenih upozorenja",
  "weatherWarnings.ended": "Završeno",
  "weatherWarnings.endedAt": "Ovo upozorenje završilo je {time}.",
  "weatherWarnings.errorBody": "Provjerite vezu. Ponovno pokušavamo svakih nekoliko minuta.",
  "weatherWarnings.errorTitle": "Učitavanje službenih upozorenja nije uspjelo",
  "weatherWarnings.fromTime": "Od {time}",
  "weatherWarnings.hazardAirQuality": "Kvaliteta zraka",
  "weatherWarnings.hazardAvalanche": "Lavine",
  "weatherWarnings.hazardCoastalEvent": "Opasnosti na obali",
  "weatherWarnings.hazardFlood": "Poplave",
  "weatherWarnings.hazardFog": "Magla",
  "weatherWarnings.hazardForestFire": "Šumski požari",
  "weatherWarnings.hazardHighTemperature": "Visoke temperature",
  "weatherWarnings.hazardLowTemperature": "Niske temperature",
  "weatherWarnings.hazardOther": "Druga opasnost",
  "weatherWarnings.hazardRain": "Kiša",
  "weatherWarnings.hazardSnowIce": "Snijeg i led",
  "weatherWarnings.hazardThunderstorm": "Grmljavinska nevremena",
  "weatherWarnings.hazardUv": "UV zračenje",
  "weatherWarnings.hazardWind": "Vjetar",
  "weatherWarnings.hideHazards": "Sakrij pojave",
  "weatherWarnings.issuedBy": "Izdao: {sender}",
  "weatherWarnings.lastUpdate": "Zadnje ažuriranje: {time}",
  "weatherWarnings.mapLabel": "{count, plural, =1 {Karta obuhvaćenog područja: {area}.} other {Karta obuhvaćenih područja, ukupno #. Istaknuto: {area}.}}",
  "weatherWarnings.mapLabelNoHighlight": "{count, plural, =1 {Karta obuhvaćenog područja.} other {Karta obuhvaćenih područja, ukupno #.}}",
  "weatherWarnings.mapUnavailable": "{count, plural, =1 {Karta nije dostupna. Područje je navedeno u nastavku.} other {Karta nije dostupna. Popis područja (#) nalazi se u nastavku.}}",
  "weatherWarnings.moreHazards": "+ još {count}: {hazards}",
  "weatherWarnings.notInLanguage": "Nije dostupno na jeziku: {language}. Prikazano kako ga je objavila meteorološka služba.",
  "weatherWarnings.openOn": "Otvori na {site}",
  "weatherWarnings.otherAreas": "{count, plural, one {+ još # područje} few {+ još # područja} other {+ još # područja}}",
  "weatherWarnings.severityExtreme": "Ekstremna",
  "weatherWarnings.severityFrom": "{severity} od {time}",
  "weatherWarnings.severityMinor": "Niska",
  "weatherWarnings.severityModerate": "Umjerena",
  "weatherWarnings.severityNow": "{severity} sada",
  "weatherWarnings.severitySevere": "Ozbiljna",
  "weatherWarnings.severityUntil": "{severity} do {time}",
  "weatherWarnings.showAllAreas": "{count, plural, one {Prikaži # područje} few {Prikaži sva # područja} other {Prikaži svih # područja}}",
  "weatherWarnings.showAllOnMap": "{count, plural, one {Prikaži # područje na karti} few {Prikaži sva # područja na karti} other {Prikaži svih # područja na karti}}",
  "weatherWarnings.showHazards": "Prikaži pojave",
  "weatherWarnings.showPeriods": "{count, plural, one {Prikaži # razdoblje} few {Prikaži sva # razdoblja} other {Prikaži svih # razdoblja}}",
  "weatherWarnings.source": "Izvor: {source}",
  "weatherWarnings.spokenHazardOne": "{hazard}: {status}.",
  "weatherWarnings.spokenHazardTwo": "{hazard}: {first}, zatim {second}.",
  "weatherWarnings.spokenLabel": "{count, plural, one {# službeno upozorenje o vremenu} few {# službena upozorenja o vremenu} other {# službenih upozorenja o vremenu}}. {hazards}",
  "weatherWarnings.spokenLabelArea": "{label} {area}.",
  "weatherWarnings.spokenPeriod": "{severity}: {range}",
  "weatherWarnings.title": "Službena upozorenja o vremenu",
  "weatherWarnings.todayAt": "danas u {time}",
  "weatherWarnings.tomorrow": "Sutra",
  "weatherWarnings.tomorrowAt": "sutra u {time}",
  "weatherWarnings.upcoming": "Nadolazeća",
  "weatherWarnings.viewAll": "Sva službena upozorenja",
  "weatherWarnings.whatToDo": "Što učiniti"
}
